webpackJsonp([1],{

/***/ "+TIe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("2IHH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2IHH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ZmY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Z61":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.2ed8810.png";

/***/ }),

/***/ "7UU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Lpx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9DLV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9reL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AygH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BHmm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DbKU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dc4F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EaBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F0Yv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA3klEQVRYR8XX0QkCMQwGYOMaBcHFhNvBLW4IwUlcJtAlepEeCiJik/wJvede/695SBs6TP4oIl9Ejn0fItqs+8GAHs7Mtx5cSlmsCAjwEX55nfxuRUAAZl5F5PpVdhMCAtRaz621h4icvAgI0ENRBAxAESEABBEG8CJCAR5EOMCKSAFYEGkALSIVoEJYby/P+n/NKr0CoyqkA4at2lNS7T/DcKItrQKa8P0VpT2NZZ02PAVgCQ8HWMNDAZ7wMIA3PASAhMMANBwGTH+WTx9Megmnjmbv7jh1OLW06F9rn51CPsg+NE0iAAAAAElFTkSuQmCC"

/***/ }),

/***/ "HOuS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAAE1Jy4DAAAAAXNSR0IArs4c6QAAAtpJREFUOBGVlE1oE1EQx7ObTaimqIkKPSiCQqGCeJMePIiiHox6C9VbME1AFKGHSih48mAvKipiPkgQQSHipVChROtVRTx4qaJiVfzAg9FDUPLpb17z1t1N0urAZObN/Oe/8ybvPZ/PIYb4mUymLdaUny7JZrN5BcO52W63jyqErlEZXZPP57c0m81FWRsgXmB3hEKhtdVq9acKGkZSrJJcLrdHHDhdLCqpf1wZ10dZzIA6jL5Ft8kH1TYMw4jDWRQKu1wnJWjvU1pLpVIUGLdspCB6Cdsfg/aO5CwvgIQJ4BPxIdg+YzdojGImeQbQZR3EHuw0OuaI3VW9jY+PXyV5X3ojOYLOUewE+oLB4KRqA2ALwKEOywL2G8ndtVrtGf4aicfj8cUVNyjAYrE4VK/XZ+wRSbCXMM/3fOELuWrXNHQBm75N38dYNyRGq+WuNmBKkMsJADmLTosDeJcNhmkYpleSEDFNc3Or1fq4tPL5ZFIWTAGqvgKMSAL/B6OMUCwTcon0XAOog7PJZDLK2g7ohFiz80dE+exx/CiMFSfA6atpAJqVIMBHkK5zAsSntTdivXM+JcFwOLwac0V8EQjKS57nlw2/c4ZYH+BWyXn5e/KdgP/1OQ4DjUZjglGnqR1EP/T9t1cip7NRtnIJHeXouODMo/zPxKVSabBSqaQpmoBsgO5koL9hfIjuczILsX2KnAnt09VeCC6y3qljHfsEK9u+h4Y7Mdv4/f71ro55/CIQnaOjk6AC0pUWumjiTwYCgetcrwdg5nXOY58nEonvFl3tB3QNHeZF9WDU8iWX/AgX+zXY88zzVy+QjskYxDfp6imkN/Dl1bQFwDRXwM/BHYFsE0epBnbKBvRxuBGKeNkZFwqFjWz7MRxb+/B4w3UuwapYLNb03hAXkLN5wUnKLhbQnpdYCsnNC6n4yxIzihOA5wSIpFlvR9VDYFmWPKqnUfs9YqT2Ff0DHB86frWE3gAAAAAASUVORK5CYII="

/***/ }),

/***/ "HeCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LHqX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "LOA1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAAH7+Yj7AAAAAXNSR0IArs4c6QAABYJJREFUWAm9WDlPZEcQ7nk8xDWcAobhCliuYDPzB1YbW5a9Xjt0bjlaO7QXWNK1I8v5Bg5svLYsS878DyAj4BgTAMIMIECY+xp/X/tVq1+/Yx6j3W2pp6uqq6rrdR3dPUoFbXl5+ceVlZVnRHP8AaHCUZpHDiITExO6E/ZyudwiATaI6zFWXM/wB2r+FSQHkbtKpaIlSPQ874lPQl9fn2pvb1eHh4dqd3f3tSciNzc3Aiofq8/s7OzMCGVycjJndLm6hYlC+IbZkJmFQkF1dHQIjzo4OFB7e3sa55cfywykBdSjjXtYv01m8RUC6tHGjYrV1dWP7u7uXoc4gfBDSDOMRNbW1h7c3t7+CXAbDI9Ik6YZuXH8aiHao2jUG5nERAHxe04AEulzu0GBRuGvOeMam8GF8ZHfZGKkYCwjl7y4uAgp9oGdoOdtqmur7/sFvT32B9kCAnOL9NKyVzIhI3xdlrmQZ4QBNk7DCTOCJ4wnXV1dxd7eXppumlGY5kXDnQzMw8JPOK0VJlnU3d2dqGJ/fz8yx8/OBQFYcmclWc/PzxUcbaYRHaqpqUmS2NAF8INoFjwyMgMl4UdGRiLzLoHxsI0+7k4IPjg4qEFadn19rXtzc7NMR0Zm9KMI1SJQETvb+vq62tzctGYj4JJ2CgpaHgXGlEFhQ1gIGBlZkOzGWESk95mw4SQi/GcMT23GLHBLS0vz0NDQOXlDCm1hKJ8D/rVNs+Al5Nnj0dHRXYumwUSFnEV8PkPAvw9wCp3OW6irq3s+Njb2N+DYFlEY7Oc/4A5VAlcae6Yrf4RuE5IyxuaxYSitjI+P13EUurGwVodQEbzL41Ur1QHGwwL0e3tXrIL8rcDawriCmM/nVWNjo/CFRub36elpiCZ76gfhEZokMjAwEKHZBOy3jaqgfs4yl5NiTQu4liCIQ4pshJWLClNbmgJXEJXrRVWFLAhs9fX1Cunl6nDxqaoKs9RAS2vx/7pkUVzQrtauI1xe4ItVFUotxIZr+TSlCJ0/qHApZqUIiWcMBFTawYWM+Q5VyH+MM6Mc0eAQWltbFXtK0+ezzhR8xg4Cs2Az89xIyxRmi91Q3Vt56NvFwVQMmzELLGlHXuMUlvEswjE889i7WaEbC4UQ9/ky546IgCeoh7/a9IhCTpZKpV446i+AD21mgaFoDoqeC26PsQptBhvmQgj0L9A/BD12MZvfgZdgyG/o38cdbg6vQasayGKOiPrBjSqjoUYAgVFG/9x1gasu1kDcXppQVl+BueZTxl2oCj6PoP1M7h42r4lqISIIp2HcGfB3ZRyXfso1ubbYIaPZQV4/8E4tvWlXykJZR7q+s7NzVF4W2sAgy3iZSr0bcRGWw/7+/qzrRfi2trYi94MIE15sKNEPmEzaxUEJqGocFd3nhI5ZOKt8PrBJ+fA7r6f3LRlm7XK5rHBVMLgLYCcU3OWSs+APaRv/K+HduebW09PDG1dIHnFk3jShiXsitI1XGl7sa24ovDXLZhCcona+OmpuGxsbiS+/o6OjmvUGgtvcwQX0xDdttRWGh4dDLMfHx+rs7ExdXl7qP1T4Fxtf6Q0NDQrlI8SbAVnw+F7LwJiZpa2tTfFyJf/2XF1d6St0DcYp2ubxMcnbRGYLMjDy3wNmLnSrYrGYmuVJ6mgTbTMnCY8ZZM1MkoDQ+Uir9q4S3riR/1IwBNIaqoB5LBsDKRDcXH6BoSF6mrI3OQfDKugf2zeciCE0Drv5ExZ+l5cFfiev0p/SSPujIwbKJA3FjjKBpt/WjgbGzGLHXriGiR2JBgoDx+Cm8yUM/QpopjPblnfgExjzEln9rdxYnPkQmsnAkESA8O2Pq/8HMPo9kHi9kU4OFn/dYcwiMvL3tL+eKJDU/gNR7UYMTyxLRQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "M1Ra":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ma8t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MzPt":
/***/ (function(module, exports) {

module.exports = {"version":"3.2.1"}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-nan.js
var is_nan = __webpack_require__("MICi");
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/index.js


vue_esm["default"].use(vuex_esm["a" /* default */]);

var state = {
  userInfo: window.localStorage.userInfo ? JSON.parse(window.localStorage.userInfo) : {}
};

var mutations = {
  //获取用户信息
  getUserInfo: function getUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  }
};

var actions = {
  userInfoAction: function userInfoAction(context, userInfo) {
    context.commit('getUserInfo', userInfo);
  }
};
/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/index.js





axios_default.a.defaults.withCredentials = false;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios_default.a.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; //配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头

//添加一个请求拦截器
axios_default.a.interceptors.request.use(function (config) {
  //console.dir(config);
  return config;
}, function (error) {
  // Do something with request error
  return promise_default.a.reject(error);
});

// 添加一个响应拦截器
axios_default.a.interceptors.response.use(function (response) {
  if (response.data && response.data.code) {
    if (parseInt(response.data.code) === 201003) {
      //未登录
      // road.showToast('warn','请重新登录')
      vue_esm["default"].$vux.toast.show({
        text: '请重新登录'
      });
      //未登录
      src_router.push({ path: '/login' });
      sessionStorage.setItem('newrouter', '');
      sessionStorage.setItem('userInfo', '');
    }
  }
  return response;
}, function (err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';break;
      case 401:
        err.message = '未授权，请重新登录(401)';break;
      case 403:
        err.message = '拒绝访问(403)';break;
      case 404:
        err.message = '请求出错(404)';break;
      case 408:
        err.message = '请求超时(408)';break;
      case 500:
        err.message = '服务器错误(500)';break;
      case 501:
        err.message = '服务未实现(501)';break;
      case 502:
        err.message = '网络错误(502)';break;
      case 503:
        err.message = '服务不可用(503)';break;
      case 504:
        err.message = '网络超时(504)';break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';break;
      default:
        err.message = '\u8FDE\u63A5\u51FA\u9519(' + err.response.status + ')!';
    }
  } else {
    err.message = '连接服务器失败!';
  }
  // alert(err.message);
  return promise_default.a.reject(err);
});

//通用方法
var api_POST = function POST(url, params) {
  return axios_default.a.post('' + url, params).then(function (res) {
    return res.data;
  });
};

var api_GET = function GET(url, params) {
  return axios_default.a.get('' + url, { params: params }).then(function (res) {
    return res.data;
  });
};

var api_PUT = function PUT(url, params) {
  return axios_default.a.put('' + url, params).then(function (res) {
    return res.data;
  });
};

var api_DELETE = function DELETE(url, params) {
  return axios_default.a.delete('' + url, { params: params }).then(function (res) {
    return res.data;
  });
};

var api_PATCH = function PATCH(url, params) {
  return axios_default.a.patch('' + url, params).then(function (res) {
    return res.data;
  });
};
var downLoad = function downLoad(url, params) {
  window.location.href = url + '?' + params;
};
// CONCATENATED MODULE: ./src/api/api_sign.js

//基地址
/* harmony default export */ var api_sign = ({
  getCode: function getCode(params) {
    return api_POST('/app/v1/login/get/code', params);
  },
  loginIn: function loginIn(params) {
    return api_POST('/app/v1/login/verify', params);
  },
  //个人信息
  psnInfo: function psnInfo(params) {
    return api_GET('/ele/v1/real/name/psn/info', params);
  },
  //企业信息
  entInfo: function entInfo(params) {
    return api_GET('/ele/v1/real/name/ent/info', params);
  },
  psnCode: function psnCode(params) {
    return api_POST('/ele/v1/real/name/psn', params);
  },
  validateCode: function validateCode(params) {
    return api_POST('/ele/v1/real/name/psn/validate/code', params);
  },
  nameent: function nameent(params) {
    return api_POST('/ele/v1/real/name/ent', params);
  },
  listall: function listall(params) {
    return api_POST('/ele/v1/real/name/ent/list/all', params);
  },
  listsubbranch: function listsubbranch(params) {
    return api_GET('/ele/v1/support/bank/list/subbranch', params);
  },
  entlist: function entlist(params) {
    return api_GET('/ele/v1/real/name/ent/list', params);
  },
  entpayment: function entpayment(params) {
    return api_POST('/ele/v1/real/name/ent/payment', params);
  },
  contractall: function contractall(params) {
    return api_GET('/ele/v1/contract/sign/info/all', params);
  },
  // contractsign:params =>{
  // return API.GET(`/ele/v1/contract/sign/info`,params)
  // },
  contractsign: function contractsign(params) {
    return api_POST('/ele/v1/contract/sign/info/list', params);
  },
  signaddress: function signaddress(params) {
    return api_GET('/ele/v1/contract/sign/address', params);
  },
  overaddress: function overaddress(params) {
    return api_GET('/ele/v1/contract/sign/over/address', params);
  },
  signGuarantee: function signGuarantee(params) {
    return api_POST('/ele/v1/contract/sign/guarantee', params);
  },
  signExtension: function signExtension(params) {
    return api_POST('/ele/v1/contract/sign/update', params);
  },
  getWxUrl: function getWxUrl(params) {
    return api_POST('/user/login/v1/wx/auth/geturl', params);
  },
  getOpenId: function getOpenId(params) {
    return api_POST('/user/login/v1/wx/openid/get', params);
  },
  signJiayuan: function signJiayuan(params) {
    return api_POST('/ele/v1/contract/sign/jiayuan', params);
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var staticRenderFns = []
var esExports = { render: swiper_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function injectStyle (ssrContext) {
  __webpack_require__("Xs3t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df815522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("BHmm")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc96ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("snx3")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fc8f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("TzZF")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("M1Ra")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc027bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/card/index.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header && _vm.header.title)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header.title)},on:{"click":function($event){return _vm.$emit('on-click-header')}}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_c('div',{staticClass:"vux-card-content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title)?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":"javascript:"},on:{"click":_vm.onClickFooter}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()]),_vm._v(" "),_vm._t("footer")],2)}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var src_components_card = (card_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/card/index.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("AygH")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  components_card,
  src_components_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_card = (card_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("sEtL")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("4ZmY")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("h5Pr")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0aeed9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("HeCi")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main.vue













/* harmony default export */ var main = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Swiper: vux_src_components_swiper_swiper,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card,
    Popup: node_modules_vux_src_components_popup,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      index: 0,
      list: [],
      demo: [],
      datas: [],
      password: '',
      mobile: this.$store.state.userInfo.phoneNo,
      show: false,
      loading: false,
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      contractId: ''
    };
  },
  created: function created() {
    this.getList();
    this.getcontract();
    console.log(this.$store.state.userInfo);
  },

  methods: {
    log: function log(str) {
      console.log(str);
    },
    getList: function getList() {
      var _this = this;

      var pp = {
        realNameTag: 1,
        enablePaging: false
      };
      api_sign.listall(pp).then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data.list;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    getcontract: function getcontract() {
      var _this2 = this;

      var pp = {
        signTag: 1,
        enablePaging: false
      };
      api_sign.contractsign(pp).then(function (res) {
        if (res.code == '000000') {
          if (res.data.list.length > 3) {
            _this2.list = res.data.list.slice(0, 3);
          } else {
            _this2.list = res.data.list;
          }
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    go: function go(customerNo) {
      this.$router.push({ path: '/checkbusiness/1', query: { customerNo: customerNo } });
    },
    gos: function gos(id, status, type) {
      var _this3 = this;

      if (status == '0' || status == '2') {
        api_sign.signaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            if (res.data.length > 0) {
              window.location.href = res.data;
            } else if (type == 'EXTENSION') {
              _this3.$router.push('/extension/' + id);
            } else {
              return;
            }
          } else {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else if (status == '1') {
        api_sign.overaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            window.location.href = res.data;
          } else {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      }
    },
    godanbao: function godanbao(id, status, category) {
      var _this4 = this;

      console.log(category);
      if (category == '4') {

        this.contractId = id;
        this.show = true;
        this.codeVal = '获取验证码';
        this.codeFlog = false;
        this.wait = 60;
        this.loading = false;
      } else {
        if (status == '0') {
          this.$router.push('/guarantee/' + id);
        } else if (status == '1') {
          api_sign.overaddress({ contractId: id }).then(function (res) {
            if (res.code == '000000') {
              window.location.href = res.data;
            } else {
              _this4.$vux.toast.show({
                type: 'cancel;',
                text: res.msg
              });
            }
          });
        }
      }
    },
    getCode: function getCode() {
      var _this5 = this;

      if (this.codeFlog) return;
      if (this.mobile !== "" && this.mobile.length === 11) {
        api_sign.getCode({ phone: this.mobile, nid: 'sign_code' }).then(function (res) {
          if (res.code == '000000') {
            _this5.time();
          } else {
            _this5.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: res.msg
        });
      }
    },
    time: function time() {
      var _this6 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this6.time();
        }, 1000);
      }
    },
    signjiayuan: function signjiayuan() {
      var _this7 = this;

      this.loading = true;
      if (this.password.length == 6) {
        api_sign.signJiayuan({ contractId: this.contractId, code: this.password }).then(function (res) {
          if (res.code == '000000') {
            _this7.$vux.toast.show({
              type: 'success;',
              text: '操作成功！'
            });
            _this7.getcontract();
            _this7.show = false;
          } else {
            _this7.loading = false;
            _this7.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '填写验证码'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/main.vue













/* harmony default export */ var pages_main = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Swiper: vux_src_components_swiper_swiper,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card,
    Popup: node_modules_vux_src_components_popup,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      index: 0,
      list: [],
      demo: [],
      datas: [],
      password: '',
      mobile: this.$store.state.userInfo.phoneNo,
      show: false,
      loading: false,
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      contractId: ''
    };
  },
  created: function created() {
    this.getList();
    this.getcontract();
    console.log(this.$store.state.userInfo);
  },

  methods: {
    log: function log(str) {
      console.log(str);
    },
    getList: function getList() {
      var _this = this;

      var pp = {
        realNameTag: 1,
        enablePaging: false
      };
      api_sign.listall(pp).then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data.list;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    getcontract: function getcontract() {
      var _this2 = this;

      var pp = {
        signTag: 1,
        enablePaging: false
      };
      api_sign.contractsign(pp).then(function (res) {
        if (res.code == '000000') {
          if (res.data.list.length > 3) {
            _this2.list = res.data.list.slice(0, 3);
          } else {
            _this2.list = res.data.list;
          }
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    go: function go(customerNo) {
      this.$router.push({ path: '/checkbusiness/1', query: { customerNo: customerNo } });
    },
    gos: function gos(id, status, type) {
      var _this3 = this;

      if (status == '0' || status == '2') {
        api_sign.signaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            if (res.data.length > 0) {
              window.location.href = res.data;
            } else if (type == 'EXTENSION') {
              _this3.$router.push('/extension/' + id);
            } else {
              return;
            }
          } else {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else if (status == '1') {
        api_sign.overaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            window.location.href = res.data;
          } else {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      }
    },
    godanbao: function godanbao(id, status, category) {
      var _this4 = this;

      console.log(category);
      if (category == '4') {

        this.contractId = id;
        this.show = true;
        this.codeVal = '获取验证码';
        this.codeFlog = false;
        this.wait = 60;
        this.loading = false;
      } else {
        if (status == '0') {
          this.$router.push('/guarantee/' + id);
        } else if (status == '1') {
          api_sign.overaddress({ contractId: id }).then(function (res) {
            if (res.code == '000000') {
              window.location.href = res.data;
            } else {
              _this4.$vux.toast.show({
                type: 'cancel;',
                text: res.msg
              });
            }
          });
        }
      }
    },
    getCode: function getCode() {
      var _this5 = this;

      if (this.codeFlog) return;
      if (this.mobile !== "" && this.mobile.length === 11) {
        api_sign.getCode({ phone: this.mobile, nid: 'sign_code' }).then(function (res) {
          if (res.code == '000000') {
            _this5.time();
          } else {
            _this5.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: res.msg
        });
      }
    },
    time: function time() {
      var _this6 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this6.time();
        }, 1000);
      }
    },
    signjiayuan: function signjiayuan() {
      var _this7 = this;

      this.loading = true;
      if (this.password.length == 6) {
        api_sign.signJiayuan({ contractId: this.contractId, code: this.password }).then(function (res) {
          if (res.code == '000000') {
            _this7.$vux.toast.show({
              type: 'success;',
              text: '操作成功！'
            });
            _this7.getcontract();
            _this7.show = false;
          } else {
            _this7.loading = false;
            _this7.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '填写验证码'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46474874","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main.vue
var main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("hDw7")}}),_vm._v(" "),_c('div',{staticClass:"titletip"},[_vm._v("待签合同")]),_vm._v(" "),(this.list.length=='0')?_c('div',{staticClass:"content"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(cols,i){return _c('div',{key:'info-'+i,staticClass:"contents1"},[(cols.type=='GUARANTEE_OFF'||cols.contractCategory=='4')?_c('div',{staticClass:"column",on:{"click":function($event){return _vm.godanbao(cols.contractId,cols.signStatus,cols.contractCategory)}}},[_c('div',{staticStyle:{"flex":"1"}},[_c('img',{staticClass:"imgs",staticStyle:{"margin-right":"10px"},attrs:{"src":__webpack_require__("+TIe")}}),_vm._v(" "),_c('div',[(cols.contractCategory=='4')?_c('div',[_c('div',{staticClass:"name"},[_vm._v("协议")])]):_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(cols.contractName))])]),_vm._v(" "),_c('div',{staticClass:"tts"},[_vm._v("签约主体："+_vm._s(cols.userName))])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"67px"}},[(cols.signStatus=='0' || cols.signStatus=='2')?_c('span',{staticClass:"not"},[_vm._v("未签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='1')?_c('span',{staticClass:"yes"},[_vm._v("已签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-2')?_c('span',{staticClass:"not"},[_vm._v("签约失败")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-1')?_c('span',{staticClass:"not"},[_vm._v("已拒签")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"tt",attrs:{"src":__webpack_require__("F0Yv")}})])]):_c('div',{staticClass:"column",class:{borderNone:i==_vm.list.length-1},on:{"click":function($event){return _vm.gos(cols.contractId,cols.signStatus,cols.type)}}},[_c('div',{staticStyle:{"flex":"1"}},[_c('img',{staticClass:"imgs",staticStyle:{"margin-right":"10px"},attrs:{"src":__webpack_require__("+TIe")}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(cols.contractName))]),_vm._v(" "),_c('div',{staticClass:"tts"},[_vm._v("签约主体："+_vm._s(cols.userName))])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"67px"}},[(cols.signStatus=='0'|| cols.signStatus=='2')?_c('span',{staticClass:"not"},[_vm._v("未签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='1')?_c('span',{staticClass:"yes"},[_vm._v("已签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-2')?_c('span',{staticClass:"not"},[_vm._v("签约失败")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-1')?_c('span',{staticClass:"not"},[_vm._v("已拒签")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"tt",attrs:{"src":__webpack_require__("F0Yv")}})])])])}),_vm._v(" "),_c('div',{staticClass:"titletip"},[_vm._v("待实名认证企业")]),_vm._v(" "),(this.datas.length=='0')?_c('div',{staticClass:"content"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.datas),function(col,i){return _c('div',{key:i,staticClass:"contents"},[_c('div',{staticClass:"column",class:{borderNone:i==_vm.datas.length-1},on:{"click":function($event){return _vm.go(col.customerNo)}}},[_c('img',{staticClass:"imgs",staticStyle:{"margin-right":"10px"},attrs:{"src":__webpack_require__("LHqX")}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticClass:"ts"},[_vm._v(_vm._s(col.name))])]),_vm._v(" "),_c('div',[(col.paymentStatus!='1')?_c('span',{staticClass:"not"},[_vm._v("未实名")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"tt",attrs:{"src":__webpack_require__("F0Yv")}})])])])}),_vm._v(" "),_c('tabbar',{staticClass:"bar"},[_c('tabbar-item',{attrs:{"selected":""}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("d1/b")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mine"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("zxUM")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的合同")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/ren"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("Pzng")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("认证信息")])])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{on:{"on-hide":function($event){return _vm.log('hide')},"on-show":function($event){return _vm.log('show')}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"popup0"},[_c('div',{staticClass:"titletip",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v("点击获取验证码后，将发送短信验证码至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.mobile))])]),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"weui-vcode",attrs:{"placeholder":"请输入验证码"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_c('x-button',{staticStyle:{"color":"#589bff"},attrs:{"slot":"right","disabled":_vm.codeFlog,"mini":""},nativeOn:{"click":function($event){return _vm.getCode($event)}},slot:"right"},[_vm._v(_vm._s(_vm.codeVal))])],1)],1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"20px"},attrs:{"type":"warn","show-loading":_vm.loading},nativeOn:{"click":function($event){return _vm.signjiayuan($event)}}},[_vm._v("签约")])],1)])],1)],2)}
var main_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('img',{staticClass:"imgs",attrs:{"src":__webpack_require__("LOA1")}}),_vm._v(" "),_c('span',{staticClass:"ts"},[_vm._v("无待签合同")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('img',{staticClass:"imgs",attrs:{"src":__webpack_require__("NKGv")}}),_vm._v(" "),_c('span',{staticClass:"ts"},[_vm._v("无待实名认证企业")]),_vm._v(" "),_c('img',{staticClass:"tt",attrs:{"src":__webpack_require__("F0Yv")}})])}]
var main_esExports = { render: main_render, staticRenderFns: main_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_main = (main_esExports);
// CONCATENATED MODULE: ./src/pages/main.vue
function main_injectStyle (ssrContext) {
  __webpack_require__("ZFLG")
}
var main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var main___vue_template_functional__ = false
/* styles */
var main___vue_styles__ = main_injectStyle
/* scopeId */
var main___vue_scopeId__ = "data-v-46474874"
/* moduleIdentifier (server only) */
var main___vue_module_identifier__ = null
var main_Component = main_normalizeComponent(
  pages_main,
  selectortype_template_index_0_src_pages_main,
  main___vue_template_functional__,
  main___vue_styles__,
  main___vue_scopeId__,
  main___vue_module_identifier__
)

/* harmony default export */ var src_pages_main = (main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checksuccess.vue
//
//
//
//
//
//
//

/* harmony default export */ var checksuccess = ({
  methods: {
    go: function go() {
      this.$router.push("/mine");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checksuccess.vue
//
//
//
//
//
//
//

/* harmony default export */ var pages_checksuccess = ({
  methods: {
    go: function go() {
      this.$router.push("/mine");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4acd8a2d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checksuccess.vue
var checksuccess_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot"},[_c('img',{staticClass:"pg",attrs:{"src":__webpack_require__("rv8P")}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("实名认证成功！")]),_vm._v(" "),_c('div',{staticClass:"pp",on:{"click":_vm.go}},[_vm._v("返回")])])}
var checksuccess_staticRenderFns = []
var checksuccess_esExports = { render: checksuccess_render, staticRenderFns: checksuccess_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_checksuccess = (checksuccess_esExports);
// CONCATENATED MODULE: ./src/pages/checksuccess.vue
function checksuccess_injectStyle (ssrContext) {
  __webpack_require__("NRm2")
}
var checksuccess_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checksuccess___vue_template_functional__ = false
/* styles */
var checksuccess___vue_styles__ = checksuccess_injectStyle
/* scopeId */
var checksuccess___vue_scopeId__ = "data-v-4acd8a2d"
/* moduleIdentifier (server only) */
var checksuccess___vue_module_identifier__ = null
var checksuccess_Component = checksuccess_normalizeComponent(
  pages_checksuccess,
  selectortype_template_index_0_src_pages_checksuccess,
  checksuccess___vue_template_functional__,
  checksuccess___vue_styles__,
  checksuccess___vue_scopeId__,
  checksuccess___vue_module_identifier__
)

/* harmony default export */ var src_pages_checksuccess = (checksuccess_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ad2681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("VcKD")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb2aed14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("DbKU")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  components_scroller,
  src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_scroller = (scroller_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/spinner/spinner.js
var spinner = __webpack_require__("P7QF");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/spinner/index.vue
//
//
//
//


var types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

/* harmony default export */ var components_spinner = ({
  name: 'spinner',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      Object(spinner["a" /* default */])(_this.$el, _this.type, _this.size);
    });
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    },
    size: String
  },
  computed: {
    styles: function styles() {
      if (typeof this.size !== 'undefined' && this.size !== '28px') {
        return {
          width: this.size,
          height: this.size
        };
      }
    },
    className: function className() {
      var rs = {};
      for (var i = 0; i < types.length; i++) {
        rs['vux-spinner-' + types[i]] = this.type === types[i];
      }
      return rs;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/spinner/index.vue
//
//
//
//


var spinner_types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

/* harmony default export */ var src_components_spinner = ({
  name: 'spinner',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      Object(spinner["a" /* default */])(_this.$el, _this.type, _this.size);
    });
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    },
    size: String
  },
  computed: {
    styles: function styles() {
      if (typeof this.size !== 'undefined' && this.size !== '28px') {
        return {
          width: this.size,
          height: this.size
        };
      }
    },
    className: function className() {
      var rs = {};
      for (var i = 0; i < spinner_types.length; i++) {
        rs['vux-spinner-' + spinner_types[i]] = this.type === spinner_types[i];
      }
      return rs;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2aa79c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/spinner/index.vue
var spinner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-spinner",class:_vm.className,style:(_vm.styles)})}
var spinner_staticRenderFns = []
var spinner_esExports = { render: spinner_render, staticRenderFns: spinner_staticRenderFns }
/* harmony default export */ var vux_src_components_spinner = (spinner_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/spinner/index.vue
function spinner_injectStyle (ssrContext) {
  __webpack_require__("xMyS")
}
var spinner_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var spinner___vue_template_functional__ = false
/* styles */
var spinner___vue_styles__ = spinner_injectStyle
/* scopeId */
var spinner___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var spinner___vue_module_identifier__ = null
var spinner_Component = spinner_normalizeComponent(
  src_components_spinner,
  vux_src_components_spinner,
  spinner___vue_template_functional__,
  spinner___vue_styles__,
  spinner___vue_scopeId__,
  spinner___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_spinner = (spinner_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74122906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("SGRN")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/mine.vue

















/* harmony default export */ var mine = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Tabbar: src_components_tabbar_tabbar,
    Scroller: vux_src_components_scroller, Spinner: node_modules_vux_src_components_spinner, LoadMore: vux_src_components_load_more,
    Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card,
    Popup: node_modules_vux_src_components_popup,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      list: [],
      signTag: 1,
      password: '',
      page: 0,
      total: 0,
      pageSize: 15,
      mobile: this.$store.state.userInfo.phone,
      show: false,
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      loading: false,
      listLoading: true,
      contractId: '',
      end: 1
    };
  },
  created: function created() {
    this.getList();
    window.addEventListener('scroll', this.onScrollg);
  },

  methods: {
    log: function log(str) {
      console.log(str);
    },
    onScrollg: function onScrollg() {
      var that = this;

      var innerHeight = document.querySelector('#app').clientHeight;

      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

      var scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight;

      if (innerHeight < scrollHeight + scrollTop + 1 && that.end != 0) {

        that.getList();
      }
    },
    handler: function handler(index) {
      if (index == 0) {
        this.signTag = 1;
      } else {
        this.signTag = 0;
      }
      this.list = [];
      this.total = 0;
      this.page = 0;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.end = 0;
      this.page++;
      var pp = {
        signTag: this.signTag,
        pageNum: this.page,
        pageSize: this.pageSize,
        enablePaging: true
      };
      this.listLoading = true;
      api_sign.contractsign(pp).then(function (res) {
        if (res.code == '000000') {
          _this.listLoading = false;
          _this.list = _this.list.concat(res.data.list);
          _this.total = Number(res.data.total);
          if (_this.total == _this.list.length) {
            _this.end = 0;
          } else {
            _this.end = 1;
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
          _this.listLoading = false;
        }
      });
    },
    gos: function gos(id, status, type, contractCategory) {
      var _this2 = this;

      if (status == '0') {
        api_sign.signaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            if (res.data.length > 0) {
              window.location.href = res.data;
            } else if (type == 'EXTENSION') {
              _this2.$router.push('/extension/' + id);
            } else {
              return;
            }
          } else {
            _this2.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else if (status == '1') {
        api_sign.overaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            if ('4' == contractCategory) {
              return;
            } else {
              window.location.href = res.data;
            }
          } else {
            _this2.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {}
    },
    godanbao: function godanbao(id, status, category) {
      var _this3 = this;

      console.log(id);
      if (category == '4') {
        if (status == '1') {
          return;
        }

        this.contractId = id;
        this.show = true;
        this.codeVal = '获取验证码';
        this.codeFlog = false;
        this.wait = 60;
        this.loading = false;
      } else {
        if (status == '0') {
          this.$router.push('/guarantee/' + id);
        } else if (status == '1') {
          api_sign.overaddress({ contractId: id }).then(function (res) {
            if (res.code == '000000') {
              window.location.href = res.data;
            } else {
              _this3.$vux.toast.show({
                type: 'cancel;',
                text: res.msg
              });
            }
          });
        }
      }
    },
    getCode: function getCode() {
      var _this4 = this;

      if (this.codeFlog) return;
      if (this.mobile !== "" && this.mobile.length === 11) {
        api_sign.getCode({ phone: this.mobile, nid: 'sign_code' }).then(function (res) {
          if (res.code == '000000') {
            _this4.time();
          } else {
            _this4.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: res.msg
        });
      }
    },
    time: function time() {
      var _this5 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this5.time();
        }, 1000);
      }
    },
    signjiayuan: function signjiayuan() {
      var _this6 = this;

      this.loading = true;
      if (this.password.length == 6) {
        api_sign.signJiayuan({ contractId: this.contractId, code: this.password }).then(function (res) {
          if (res.code == '000000') {
            _this6.$vux.toast.show({
              type: 'success;',
              text: '操作成功！'
            });
            _this6.show = false;
            _this6.getList();
          } else {
            _this6.loading = false;
            _this6.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '填写验证码'
        });
      }
    }
  },
  destroyed: function destroyed() {
    var that = this;
    window.removeEventListener('scroll', that.onScrollg);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/mine.vue

















/* harmony default export */ var pages_mine = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Tabbar: src_components_tabbar_tabbar,
    Scroller: vux_src_components_scroller, Spinner: node_modules_vux_src_components_spinner, LoadMore: vux_src_components_load_more,
    Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card,
    Popup: node_modules_vux_src_components_popup,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      list: [],
      signTag: 1,
      password: '',
      page: 0,
      total: 0,
      pageSize: 15,
      mobile: this.$store.state.userInfo.phone,
      show: false,
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      loading: false,
      listLoading: true,
      contractId: '',
      end: 1
    };
  },
  created: function created() {
    this.getList();
    window.addEventListener('scroll', this.onScrollg);
  },

  methods: {
    log: function log(str) {
      console.log(str);
    },
    onScrollg: function onScrollg() {
      var that = this;

      var innerHeight = document.querySelector('#app').clientHeight;

      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

      var scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight;

      if (innerHeight < scrollHeight + scrollTop + 1 && that.end != 0) {

        that.getList();
      }
    },
    handler: function handler(index) {
      if (index == 0) {
        this.signTag = 1;
      } else {
        this.signTag = 0;
      }
      this.list = [];
      this.total = 0;
      this.page = 0;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.end = 0;
      this.page++;
      var pp = {
        signTag: this.signTag,
        pageNum: this.page,
        pageSize: this.pageSize,
        enablePaging: true
      };
      this.listLoading = true;
      api_sign.contractsign(pp).then(function (res) {
        if (res.code == '000000') {
          _this.listLoading = false;
          _this.list = _this.list.concat(res.data.list);
          _this.total = Number(res.data.total);
          if (_this.total == _this.list.length) {
            _this.end = 0;
          } else {
            _this.end = 1;
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
          _this.listLoading = false;
        }
      });
    },
    gos: function gos(id, status, type, contractCategory) {
      var _this2 = this;

      if (status == '0') {
        api_sign.signaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            if (res.data.length > 0) {
              window.location.href = res.data;
            } else if (type == 'EXTENSION') {
              _this2.$router.push('/extension/' + id);
            } else {
              return;
            }
          } else {
            _this2.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else if (status == '1') {
        api_sign.overaddress({ contractId: id }).then(function (res) {
          if (res.code == '000000') {
            if ('4' == contractCategory) {
              return;
            } else {
              window.location.href = res.data;
            }
          } else {
            _this2.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {}
    },
    godanbao: function godanbao(id, status, category) {
      var _this3 = this;

      console.log(id);
      if (category == '4') {
        if (status == '1') {
          return;
        }

        this.contractId = id;
        this.show = true;
        this.codeVal = '获取验证码';
        this.codeFlog = false;
        this.wait = 60;
        this.loading = false;
      } else {
        if (status == '0') {
          this.$router.push('/guarantee/' + id);
        } else if (status == '1') {
          api_sign.overaddress({ contractId: id }).then(function (res) {
            if (res.code == '000000') {
              window.location.href = res.data;
            } else {
              _this3.$vux.toast.show({
                type: 'cancel;',
                text: res.msg
              });
            }
          });
        }
      }
    },
    getCode: function getCode() {
      var _this4 = this;

      if (this.codeFlog) return;
      if (this.mobile !== "" && this.mobile.length === 11) {
        api_sign.getCode({ phone: this.mobile, nid: 'sign_code' }).then(function (res) {
          if (res.code == '000000') {
            _this4.time();
          } else {
            _this4.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: res.msg
        });
      }
    },
    time: function time() {
      var _this5 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this5.time();
        }, 1000);
      }
    },
    signjiayuan: function signjiayuan() {
      var _this6 = this;

      this.loading = true;
      if (this.password.length == 6) {
        api_sign.signJiayuan({ contractId: this.contractId, code: this.password }).then(function (res) {
          if (res.code == '000000') {
            _this6.$vux.toast.show({
              type: 'success;',
              text: '操作成功！'
            });
            _this6.show = false;
            _this6.getList();
          } else {
            _this6.loading = false;
            _this6.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '填写验证码'
        });
      }
    }
  },
  destroyed: function destroyed() {
    var that = this;
    window.removeEventListener('scroll', that.onScrollg);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c023c22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine.vue
var mine_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('tab',{attrs:{"line-width":1,"custom-bar-width":"60px"}},[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.handler}},[_vm._v("未签约")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.handler}},[_vm._v("已签约")])],1)],1),_vm._v(" "),_c('div',[(this.list.length=='0')?_c('div',{staticClass:"content"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(cols,i){return _c('div',{key:'info-'+i,staticClass:"contents1"},[(cols.type=='GUARANTEE_OFF'||cols.contractCategory=='4')?_c('div',{staticClass:"column",on:{"click":function($event){return _vm.godanbao(cols.contractId,cols.signStatus,cols.contractCategory)}}},[(cols.contractCategory=='4')?_c('div'):_c('div',[_c('div',{staticStyle:{"flex":"1"}},[_c('img',{staticClass:"imgs",staticStyle:{"margin-right":"10px"},attrs:{"src":__webpack_require__("+TIe")}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(cols.contractName))]),_vm._v(" "),_c('div',{staticClass:"tts"},[_vm._v("签约主体："+_vm._s(cols.loanUserName))])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"67px"}},[(cols.signStatus=='0')?_c('span',{staticClass:"not"},[_vm._v("未签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='1')?_c('span',{staticClass:"yes"},[_vm._v("已签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-2')?_c('span',{staticClass:"not"},[_vm._v("签约失败")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-1')?_c('span',{staticClass:"not"},[_vm._v("已拒签")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"tt",attrs:{"src":__webpack_require__("F0Yv")}})])])]):_c('div',{staticClass:"column",class:{borderNone:i==_vm.list.length-1},on:{"click":function($event){return _vm.gos(cols.contractId,cols.signStatus,cols.type,cols.contractCategory)}}},[_c('div',{staticStyle:{"flex":"1 1 auto"}},[_c('img',{staticClass:"imgs",staticStyle:{"margin-right":"10px"},attrs:{"src":__webpack_require__("+TIe")}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"name"},[_vm._v(_vm._s(cols.contractName)),(cols.loanAmount > 0 )?_c('span',{staticClass:"money",staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(cols.loanAmount)+"元")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tts"},[_vm._v("签约主体:"+_vm._s(cols.loanUserName))])])]),_vm._v(" "),_c('div',[(cols.signStatus=='0')?_c('span',{staticClass:"not"},[_vm._v("未签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='1')?_c('span',{staticClass:"yes"},[_vm._v("已签约")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-2')?_c('span',{staticClass:"not"},[_vm._v("签约失败")]):_vm._e(),_vm._v(" "),(cols.signStatus=='-1')?_c('span',{staticClass:"not"},[_vm._v("已拒签")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"tt",attrs:{"src":__webpack_require__("F0Yv")}})])])])}),_vm._v(" "),(_vm.listLoading)?_c('load-more',{attrs:{"tip":"加载中"}}):_vm._e()],2),_vm._v(" "),_c('tabbar',{staticClass:"bar"},[_c('tabbar-item',{attrs:{"link":"/"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("HOuS")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mine","selected":""}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("P/Wj")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的合同")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/ren"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("Pzng")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("认证信息")])])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{on:{"on-hide":function($event){return _vm.log('hide')},"on-show":function($event){return _vm.log('show')}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"popup0"},[_c('div',{staticClass:"titletip",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v("点击获取验证码后，将发送短信验证码至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.mobile))])]),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"验证码","placeholder":"请输入6位验证码"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_c('x-button',{staticStyle:{"color":"#589bff"},attrs:{"slot":"right","disabled":_vm.codeFlog,"mini":""},nativeOn:{"click":function($event){return _vm.getCode($event)}},slot:"right"},[_vm._v(_vm._s(_vm.codeVal))])],1)],1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"50px"},attrs:{"type":"warn","show-loading":_vm.loading},nativeOn:{"click":function($event){return _vm.signjiayuan($event)}}},[_vm._v("签约")])],1)])],1)],1)}
var mine_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('img',{staticClass:"imgs",attrs:{"src":__webpack_require__("LOA1")}}),_vm._v(" "),_c('span',{staticClass:"ts"},[_vm._v("暂无合同")])])}]
var mine_esExports = { render: mine_render, staticRenderFns: mine_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_mine = (mine_esExports);
// CONCATENATED MODULE: ./src/pages/mine.vue
function mine_injectStyle (ssrContext) {
  __webpack_require__("vcYW")
}
var mine_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mine___vue_template_functional__ = false
/* styles */
var mine___vue_styles__ = mine_injectStyle
/* scopeId */
var mine___vue_scopeId__ = "data-v-5c023c22"
/* moduleIdentifier (server only) */
var mine___vue_module_identifier__ = null
var mine_Component = mine_normalizeComponent(
  pages_mine,
  selectortype_template_index_0_src_pages_mine,
  mine___vue_template_functional__,
  mine___vue_styles__,
  mine___vue_scopeId__,
  mine___vue_module_identifier__
)

/* harmony default export */ var src_pages_mine = (mine_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b5af26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
var cell_form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-cell-form-preview",class:{'vux-cell-no-border-intent': !_vm.borderIntent}},[_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(item.value)}})])}),0)])}
var cell_form_preview_staticRenderFns = []
var cell_form_preview_esExports = { render: cell_form_preview_render, staticRenderFns: cell_form_preview_staticRenderFns }
/* harmony default export */ var src_components_cell_form_preview = (cell_form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-form-preview/index.vue
function cell_form_preview_injectStyle (ssrContext) {
  __webpack_require__("9reL")
}
var cell_form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_form_preview___vue_template_functional__ = false
/* styles */
var cell_form_preview___vue_styles__ = cell_form_preview_injectStyle
/* scopeId */
var cell_form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_form_preview___vue_module_identifier__ = null
var cell_form_preview_Component = cell_form_preview_normalizeComponent(
  components_cell_form_preview,
  src_components_cell_form_preview,
  cell_form_preview___vue_template_functional__,
  cell_form_preview___vue_styles__,
  cell_form_preview___vue_scopeId__,
  cell_form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_form_preview = (cell_form_preview_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("euia")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ren.vue











/* harmony default export */ var ren = ({
  components: {
    Swiper: vux_src_components_swiper_swiper,
    Tabbar: src_components_tabbar_tabbar,
    Confirm: node_modules_vux_src_components_confirm,
    TabbarItem: src_components_tabbar_tabbar_item,
    Card: vux_src_components_card, Group: vux_src_components_group, Cell: vux_src_components_cell, CellFormPreview: vux_src_components_cell_form_preview
  },
  data: function data() {
    return {
      datas1: {},
      show: false
    };
  },
  created: function created() {
    this.dos();
  },

  methods: {
    dos: function dos() {
      var _this = this;

      api_sign.psnInfo().then(function (res) {
        if (res.code == '000000') {
          _this.datas1 = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    out: function out() {
      this.show = true;
    },
    onConfirm: function onConfirm() {
      window.localStorage.setItem('userInfo', '');
      this.$router.push("/login");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ren.vue











/* harmony default export */ var pages_ren = ({
  components: {
    Swiper: vux_src_components_swiper_swiper,
    Tabbar: src_components_tabbar_tabbar,
    Confirm: node_modules_vux_src_components_confirm,
    TabbarItem: src_components_tabbar_tabbar_item,
    Card: vux_src_components_card, Group: vux_src_components_group, Cell: vux_src_components_cell, CellFormPreview: vux_src_components_cell_form_preview
  },
  data: function data() {
    return {
      datas1: {},
      show: false
    };
  },
  created: function created() {
    this.dos();
  },

  methods: {
    dos: function dos() {
      var _this = this;

      api_sign.psnInfo().then(function (res) {
        if (res.code == '000000') {
          _this.datas1 = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    out: function out() {
      this.show = true;
    },
    onConfirm: function onConfirm() {
      window.localStorage.setItem('userInfo', '');
      this.$router.push("/login");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f19d46fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ren.vue
var ren_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('cell',{attrs:{"title":"姓名","value":_vm.datas1.userName}}),_vm._v(" "),_c('cell',{attrs:{"title":"身份证号","value":_vm.datas1.idNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"手机号","value":_vm.datas1.phoneNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"银行卡号","value":_vm.datas1.bankNo}})],1),_vm._v(" "),_c('group',[_c('cell',{attrs:{"title":"我的企业","is-link":"","link":"/entList"}})],1),_vm._v(" "),_c('div',{staticClass:"out",on:{"click":_vm.out}},[_vm._v("退出")]),_vm._v(" "),_c('confirm',{attrs:{"close-on-confirm":false},on:{"on-confirm":_vm.onConfirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("\n      是否退出？\n    ")]),_vm._v(" "),_c('tabbar',{staticClass:"bar"},[_c('tabbar-item',{attrs:{"link":"/"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("HOuS")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mine"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("zxUM")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的合同")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":"","link":"/ren"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("lay7")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("认证信息")])])],1)],1)}
var ren_staticRenderFns = []
var ren_esExports = { render: ren_render, staticRenderFns: ren_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_ren = (ren_esExports);
// CONCATENATED MODULE: ./src/pages/ren.vue
function ren_injectStyle (ssrContext) {
  __webpack_require__("9DLV")
}
var ren_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ren___vue_template_functional__ = false
/* styles */
var ren___vue_styles__ = ren_injectStyle
/* scopeId */
var ren___vue_scopeId__ = "data-v-f19d46fc"
/* moduleIdentifier (server only) */
var ren___vue_module_identifier__ = null
var ren_Component = ren_normalizeComponent(
  pages_ren,
  selectortype_template_index_0_src_pages_ren,
  ren___vue_template_functional__,
  ren___vue_styles__,
  ren___vue_scopeId__,
  ren___vue_module_identifier__
)

/* harmony default export */ var src_pages_ren = (ren_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3971d056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var view_box_staticRenderFns = []
var view_box_esExports = { render: view_box_render, staticRenderFns: view_box_staticRenderFns }
/* harmony default export */ var src_components_view_box = (view_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function view_box_injectStyle (ssrContext) {
  __webpack_require__("oWja")
}
var view_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var view_box___vue_template_functional__ = false
/* styles */
var view_box___vue_styles__ = view_box_injectStyle
/* scopeId */
var view_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var view_box___vue_module_identifier__ = null
var view_box_Component = view_box_normalizeComponent(
  components_view_box,
  src_components_view_box,
  view_box___vue_template_functional__,
  view_box___vue_styles__,
  view_box___vue_scopeId__,
  view_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (view_box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("EaBg")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var components_box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53121ac7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/box/index.vue
var box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({margin:_vm.gap})},[_vm._t("default")],2)}
var box_staticRenderFns = []
var box_esExports = { render: box_render, staticRenderFns: box_staticRenderFns }
/* harmony default export */ var src_components_box = (box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/box/index.vue
var box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var box___vue_template_functional__ = false
/* styles */
var box___vue_styles__ = null
/* scopeId */
var box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var box___vue_module_identifier__ = null
var box_Component = box_normalizeComponent(
  components_box,
  src_components_box,
  box___vue_template_functional__,
  box___vue_styles__,
  box___vue_scopeId__,
  box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_box = (box_Component.exports);

// EXTERNAL MODULE: ./node_modules/jsencrypt/lib/index.js + 14 modules
var lib = __webpack_require__("NMjF");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/login.vue










/* harmony default export */ var login = ({
  name: 'signIn',
  components: {
    ViewBox: vux_src_components_view_box, XHeader: vux_src_components_x_header, Box: vux_src_components_box, XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      isActive: false,
      falseword: '',
      isActive1: false,
      falseword1: '',
      mobile: '',
      code: '',
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      show: false,
      openId: ""
    };
  },

  mounted: function mounted() {},
  methods: {
    check: function check() {
      if (this.mobile === "") {
        this.isActive = true;
        this.falseword = '手机号码不能为空';
      } else if (this.mobile.length != 11) {
        this.isActive = true;
        this.falseword = '手机号码错误';
      } else {
        this.isActive = false;
        this.falseword = '';
      }
    },
    check1: function check1() {
      if (this.code === "") {
        this.isActive1 = true;
        this.falseword1 = '验证码不能为空';
      } else {
        this.isActive1 = false;
        this.falseword1 = '';
      }
    },
    register: function register() {
      var _this = this;

      if (this.mobile === "") {
        this.isActive = true;
        this.falseword = '手机号码不能为空';
        return;
      }
      if (this.mobile.length != 11) {
        this.isActive = true;
        this.falseword = '手机号码错误';
        return;
      }
      if (this.code === "") {
        this.isActive1 = true;
        this.falseword1 = '验证码不能为空';
        return;
      }
      var encryptor = new lib["a" /* default */]();
      var publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAykMtXKdPRM4YX6vEuhjsF4ihwwXjng0EAEHn2ujTPcDgkfpeNeLzADIwLe8nV7PPnOrUNrYl57xKLVBmnX/qw/5oDNNMDUkpL0aIFiIKdKJV8ahUyp+klQir/FnydAhGcDjLgkHj9WEdnGiyFJUDEUDasqyBB/OsNGuGIc4PW8AgjYjHBnL7gZyMhQ1FSLG9w0AePDaGQEymhCsY+7m1LNLAq89Gm5fx0A/hUR8117iaa9DVKzJnS3gu+m1vEHIh9b9ui121pUVgNYA8td3jNCxY9Qdwfi8+vms3inDbFRHpj+HHnlO+vlfO4lP+zXHQ7otVlevCt4mkwyqF1HLTXwIDAQAB';
      encryptor.setPublicKey(publicKey);
      var passwordEncryp = encryptor.encrypt(this.mobile);
      var params = { "phone": passwordEncryp, "code": this.code, "channel": "sign" };

      api_sign.loginIn(params).then(function (res) {
        if (res.code == '000000') {
          _this.$store.dispatch('userInfoAction', res.data);
          window.localStorage.setItem('userInfo', stringify_default()(res.data));
          if (res.data.realNameStatus == "0") {
            _this.$router.push("/check");
          } else {
            _this.$router.push("/");
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    getCode: function getCode() {
      var _this2 = this;

      if (this.codeFlog) return;
      if (this.mobile !== "" && this.mobile.length === 11) {
        this.time();
        var encryptor = new lib["a" /* default */]();
        var publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAykMtXKdPRM4YX6vEuhjsF4ihwwXjng0EAEHn2ujTPcDgkfpeNeLzADIwLe8nV7PPnOrUNrYl57xKLVBmnX/qw/5oDNNMDUkpL0aIFiIKdKJV8ahUyp+klQir/FnydAhGcDjLgkHj9WEdnGiyFJUDEUDasqyBB/OsNGuGIc4PW8AgjYjHBnL7gZyMhQ1FSLG9w0AePDaGQEymhCsY+7m1LNLAq89Gm5fx0A/hUR8117iaa9DVKzJnS3gu+m1vEHIh9b9ui121pUVgNYA8td3jNCxY9Qdwfi8+vms3inDbFRHpj+HHnlO+vlfO4lP+zXHQ7otVlevCt4mkwyqF1HLTXwIDAQAB';
        encryptor.setPublicKey(publicKey);
        var passwordEncryp = encryptor.encrypt(this.mobile);
        var param = new FormData();
        param.append("phone", passwordEncryp);
        param.append("nide", "login_code");
        param.append("channel", 'sign');
        api_sign.getCode(param).then(function (res) {
          if (res.code == '000000') {} else {
            _this2.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.isActive = true;
        this.falseword = '手机号码错误';
      }
    },
    time: function time() {
      var _this3 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this3.time();
        }, 1000);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/login.vue










/* harmony default export */ var pages_login = ({
  name: 'signIn',
  components: {
    ViewBox: vux_src_components_view_box, XHeader: vux_src_components_x_header, Box: vux_src_components_box, XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      isActive: false,
      falseword: '',
      isActive1: false,
      falseword1: '',
      mobile: '',
      code: '',
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      show: false,
      openId: ""
    };
  },

  mounted: function mounted() {},
  methods: {
    check: function check() {
      if (this.mobile === "") {
        this.isActive = true;
        this.falseword = '手机号码不能为空';
      } else if (this.mobile.length != 11) {
        this.isActive = true;
        this.falseword = '手机号码错误';
      } else {
        this.isActive = false;
        this.falseword = '';
      }
    },
    check1: function check1() {
      if (this.code === "") {
        this.isActive1 = true;
        this.falseword1 = '验证码不能为空';
      } else {
        this.isActive1 = false;
        this.falseword1 = '';
      }
    },
    register: function register() {
      var _this = this;

      if (this.mobile === "") {
        this.isActive = true;
        this.falseword = '手机号码不能为空';
        return;
      }
      if (this.mobile.length != 11) {
        this.isActive = true;
        this.falseword = '手机号码错误';
        return;
      }
      if (this.code === "") {
        this.isActive1 = true;
        this.falseword1 = '验证码不能为空';
        return;
      }
      var encryptor = new lib["a" /* default */]();
      var publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAykMtXKdPRM4YX6vEuhjsF4ihwwXjng0EAEHn2ujTPcDgkfpeNeLzADIwLe8nV7PPnOrUNrYl57xKLVBmnX/qw/5oDNNMDUkpL0aIFiIKdKJV8ahUyp+klQir/FnydAhGcDjLgkHj9WEdnGiyFJUDEUDasqyBB/OsNGuGIc4PW8AgjYjHBnL7gZyMhQ1FSLG9w0AePDaGQEymhCsY+7m1LNLAq89Gm5fx0A/hUR8117iaa9DVKzJnS3gu+m1vEHIh9b9ui121pUVgNYA8td3jNCxY9Qdwfi8+vms3inDbFRHpj+HHnlO+vlfO4lP+zXHQ7otVlevCt4mkwyqF1HLTXwIDAQAB';
      encryptor.setPublicKey(publicKey);
      var passwordEncryp = encryptor.encrypt(this.mobile);
      var params = { "phone": passwordEncryp, "code": this.code, "channel": "sign" };

      api_sign.loginIn(params).then(function (res) {
        if (res.code == '000000') {
          _this.$store.dispatch('userInfoAction', res.data);
          window.localStorage.setItem('userInfo', stringify_default()(res.data));
          if (res.data.realNameStatus == "0") {
            _this.$router.push("/check");
          } else {
            _this.$router.push("/");
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    getCode: function getCode() {
      var _this2 = this;

      if (this.codeFlog) return;
      if (this.mobile !== "" && this.mobile.length === 11) {
        this.time();
        var encryptor = new lib["a" /* default */]();
        var publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAykMtXKdPRM4YX6vEuhjsF4ihwwXjng0EAEHn2ujTPcDgkfpeNeLzADIwLe8nV7PPnOrUNrYl57xKLVBmnX/qw/5oDNNMDUkpL0aIFiIKdKJV8ahUyp+klQir/FnydAhGcDjLgkHj9WEdnGiyFJUDEUDasqyBB/OsNGuGIc4PW8AgjYjHBnL7gZyMhQ1FSLG9w0AePDaGQEymhCsY+7m1LNLAq89Gm5fx0A/hUR8117iaa9DVKzJnS3gu+m1vEHIh9b9ui121pUVgNYA8td3jNCxY9Qdwfi8+vms3inDbFRHpj+HHnlO+vlfO4lP+zXHQ7otVlevCt4mkwyqF1HLTXwIDAQAB';
        encryptor.setPublicKey(publicKey);
        var passwordEncryp = encryptor.encrypt(this.mobile);
        var param = new FormData();
        param.append("phone", passwordEncryp);
        param.append("nide", "login_code");
        param.append("channel", 'sign');
        api_sign.getCode(param).then(function (res) {
          if (res.code == '000000') {} else {
            _this2.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.isActive = true;
        this.falseword = '手机号码错误';
      }
    },
    time: function time() {
      var _this3 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this3.time();
        }, 1000);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4a1a62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('view-box',{staticClass:"signIn",attrs:{"bodyPaddingTop":"0","bodyPaddingBottom":"0"}},[_c('img',{staticClass:"pg",attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('div',{staticClass:"inbox",staticStyle:{"margin-top":"40px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],staticClass:"column",class:{ false: _vm.isActive},attrs:{"type":"tel","placeholder":"请输入手机号"},domProps:{"value":(_vm.mobile)},on:{"change":_vm.check,"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"falsem"},[_vm._v(_vm._s(_vm.falseword))])]),_vm._v(" "),_c('div',{staticClass:"inbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"column",class:{ false: _vm.isActive1},attrs:{"maxlength":"6","placeholder":"请输入验证码"},domProps:{"value":(_vm.code)},on:{"change":_vm.check1,"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"falsem"},[_vm._v(_vm._s(_vm.falseword1))]),_vm._v(" "),_c('span',{staticClass:"ui-code",class:{falsecode:_vm.codeFlog},on:{"click":function($event){return _vm.getCode()}}},[_vm._v(_vm._s(_vm.codeVal))])]),_vm._v(" "),_c('box',{attrs:{"gap":"10px 10px"}},[_c('x-button',{staticClass:"btn",attrs:{"plain":""},nativeOn:{"click":function($event){return _vm.register($event)}}},[_vm._v("提交")])],1)],1)],1)}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_login = (login_esExports);
// CONCATENATED MODULE: ./src/pages/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("xK84")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-7b4a1a62"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  pages_login,
  selectortype_template_index_0_src_pages_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_pages_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("5Z61")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/alert/index.vue + 3 modules
var components_alert = __webpack_require__("mzja");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de9c80d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("dJ9g")
}
var check_icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_check_icon = (check_icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/check.vue


var _components;















/* harmony default export */ var check = ({
  created: function created() {
    this.dos();
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: (_components = {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading
  }, defineProperty_default()(_components, 'XButton', vux_src_components_x_button), defineProperty_default()(_components, 'Box', vux_src_components_box), defineProperty_default()(_components, 'Toast', toast["a" /* default */]), defineProperty_default()(_components, 'XDialog', x_dialog["a" /* default */]), defineProperty_default()(_components, 'CheckIcon', vux_src_components_check_icon), _components),
  data: function data() {
    var _ref;

    return _ref = {
      show: false,
      datas: {},
      bankNo: '',
      flowId: '',
      code: '',
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60
    }, defineProperty_default()(_ref, 'show', false), defineProperty_default()(_ref, 'isagree', false), _ref;
  },

  methods: {
    dos: function dos() {
      var _this = this;

      api_sign.psnInfo().then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (this.bankNo === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '银行卡号不能为空'
        });
        return;
      }
      if (this.authNo === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '银行卡号错误'
        });
        return;
      }
      if (this.code === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '验证码不能为空'
        });
        return;
      }

      if (this.isagree == false) {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '请勾选协议'
        });
        return;
      }
      var param = new FormData();
      param.append("flowId", this.flowId);
      param.append("code", this.code);
      api_sign.validateCode(param).then(function (res) {
        if (res.code == '000000') {
          _this2.$router.push('/checksuc');
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    getCode: function getCode() {
      var _this3 = this;

      if (this.codeFlog) return;
      if (this.bankNo !== "") {
        var param = new FormData();
        param.append("bankNo", this.bankNo);
        api_sign.psnCode(param).then(function (res) {
          if (res.code == '000000') {
            _this3.flowId = res.data.flowId;
            _this3.time();
          } else {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '银行卡号不能为空'
        });
      }
    },
    time: function time() {
      var _this4 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this4.time();
        }, 1000);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/check.vue


var check__components;















/* harmony default export */ var pages_check = ({
  created: function created() {
    this.dos();
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: (check__components = {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading
  }, defineProperty_default()(check__components, 'XButton', vux_src_components_x_button), defineProperty_default()(check__components, 'Box', vux_src_components_box), defineProperty_default()(check__components, 'Toast', toast["a" /* default */]), defineProperty_default()(check__components, 'XDialog', x_dialog["a" /* default */]), defineProperty_default()(check__components, 'CheckIcon', vux_src_components_check_icon), check__components),
  data: function data() {
    var _ref;

    return _ref = {
      show: false,
      datas: {},
      bankNo: '',
      flowId: '',
      code: '',
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60
    }, defineProperty_default()(_ref, 'show', false), defineProperty_default()(_ref, 'isagree', false), _ref;
  },

  methods: {
    dos: function dos() {
      var _this = this;

      api_sign.psnInfo().then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (this.bankNo === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '银行卡号不能为空'
        });
        return;
      }
      if (this.authNo === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '银行卡号错误'
        });
        return;
      }
      if (this.code === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '验证码不能为空'
        });
        return;
      }

      if (this.isagree == false) {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '请勾选协议'
        });
        return;
      }
      var param = new FormData();
      param.append("flowId", this.flowId);
      param.append("code", this.code);
      api_sign.validateCode(param).then(function (res) {
        if (res.code == '000000') {
          _this2.$router.push('/checksuc');
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    getCode: function getCode() {
      var _this3 = this;

      if (this.codeFlog) return;
      if (this.bankNo !== "") {
        var param = new FormData();
        param.append("bankNo", this.bankNo);
        api_sign.psnCode(param).then(function (res) {
          if (res.code == '000000') {
            _this3.flowId = res.data.flowId;
            _this3.time();
          } else {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '银行卡号不能为空'
        });
      }
    },
    time: function time() {
      var _this4 = this;

      if (this.wait === 0) {
        this.codeFlog = false;
        this.codeVal = "获取验证码";
        this.wait = 60;
      } else {
        this.codeFlog = true;
        this.codeVal = "重新发送(" + this.wait + ")";
        this.wait--;
        setTimeout(function () {
          _this4.time();
        }, 1000);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71959789","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/check.vue
var check_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{staticClass:"bb"},[_c('cell',{attrs:{"title":"用户姓名","value":_vm.datas.userName}}),_vm._v(" "),_c('cell',{attrs:{"title":"手机号码","value":_vm.datas.phoneNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"身份证号","value":_vm.datas.idNo}}),_vm._v(" "),_c('x-input',{attrs:{"title":"银行卡号","placeholder":"请输入银行卡号","text-align":"right"},model:{value:(_vm.bankNo),callback:function ($$v) {_vm.bankNo=$$v},expression:"bankNo"}})],1),_vm._v(" "),_c('group',{staticClass:"pp"},[_c('x-input',{attrs:{"title":"验证码 ","placeholder":"请输入验证码"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('span',{staticClass:"ui-code",on:{"click":function($event){return _vm.getCode()}}},[_vm._v(_vm._s(_vm.codeVal))])],1),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("请仔细核实以上信息，如果存在错误，请联系客服")]),_vm._v(" "),_c('box',{staticStyle:{"text-align":"center","margin-top":"30px"},attrs:{"gap":"10px 10px"}},[_c('label',{staticClass:"lb"},[_c('check-icon',{attrs:{"value":_vm.isagree},on:{"update:value":function($event){_vm.isagree=$event}}},[_vm._v("同意"),_c('a',{staticStyle:{"color":"#0092fe"},on:{"click":function($event){_vm.show=true}}},[_vm._v("《实名认证协议》")])])],1),_vm._v(" "),_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("提交")])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{staticClass:"dialog-demo",attrs:{"hide-on-blur":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"content"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("实名认证服务协议")]),_vm._v(" "),_c('p',[_vm._v("实名认证服务协议（以下简称“本协议”）是杭州浙农互联网金融服务有限公司（以下简称“浙农网络小贷”）与用户（以下尊 称“您”）就实名认证服务（以下简称“本服务”或“认证服务”）的使用等相关事项所订立的有效合约。 本协议有助于您了解我们为您提供的服务内容及您的权利和义务，请您仔细阅读。 为便于您使用认证服务，您通过网络页面点击或以其他形式确认本协议的，即视为您已充分理解本协议所有条款，并同意与浙农网络小贷订立本协议并接受本协议的约束。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("一、服务内容")]),_vm._v(" "),_c('p',[_vm._v("实名认证服务：指浙农网络小贷平台用户签署实名认证服务协议，采用身份证、手机号码等进行实名认证。经本平台核实有效后，给与用户实名认证标识的服务。完成实名认证的用户，方可进行贷款申请。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("二、授权与许可")]),_vm._v(" "),_c('p',[_vm._v("1、为了准确核验您的身份，尽量防止您的身份被冒用，您授权浙农网络小贷采集您的设备信息以验证您在进行认证时是否处于可信环境，并根据不同的认证方式按需收集您的身份证件、银行卡号、手机号、企业注册号、企业对公账户等信息。")]),_vm._v(" "),_c('p',[_vm._v("2、为准确验证您的身份，浙农网络小贷需将前款载明的信息提供给合法存有您信息的第三方机构进行比对核验，以便浙农网络小贷核验您的身份真实性。")]),_vm._v(" "),_c('p',[_vm._v("3、实名认证服务适用于本平台的所有用户。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("三、隐私保护")]),_vm._v(" "),_c('p',[_vm._v("1、您在认证时提交给本平台的认证资料，即不可撤销的授权由本平台保留。本平台承诺除法定或约定的事由外，不公开或编辑或透露您的认证资料及保存于本平台的非公开内容用于商业目的，但下列情况除外：")]),_vm._v(" "),_c('p',[_vm._v("（1）您授权本平台透露的相关信息；")]),_vm._v(" "),_c('p',[_vm._v("（2）本平台向国家司法及行政机关提供；")]),_vm._v(" "),_c('p',[_vm._v("（3）第三方和本平台一起为用户提供服务时，该第三方向您提供服务所需的相关信息；")]),_vm._v(" "),_c('p',[_vm._v("我们将采取合理的方式保护您个人资料的安全。我们将使用必要的可以获得的安全技术和程序来保护您的个人资料不被未经授权的访问、使用或泄露。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("四、免责条款")]),_vm._v(" "),_c('p',[_vm._v("您理解并同意，鉴于计算机、互联网的特殊性，下述情况不属于浙农网络小贷违约：")]),_vm._v(" "),_c('p',[_vm._v("1、因自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、网路堵塞、电信部门技术调整和政府管制等导致本服务不能提供或中断；")]),_vm._v(" "),_c('p',[_vm._v("2、黑客攻击造成服务中断、信息数据泄露；但我们应按照本协议约定做好应急处理。")]),_vm._v(" "),_c('p',[_vm._v("3、浙农网络小贷在进行服务器配置、维护时，需要短时间中断服务；")]),_vm._v(" "),_c('p',[_vm._v("4、由于Internet上的通路阻塞造成您网站访问速度下降；")]),_vm._v(" "),_c('p',[_vm._v("5、因国家法律法规及政策的相关要求，中断或终止本服务。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("五、协议变更")]),_vm._v(" "),_c('p',[_vm._v("为了满足您多样化和专业化的服务需求，我们将根据国家法律、法规及其他规范性文件及业务需要，可能增加、变更服务内容或服务方式，并通过本公司平台进行公告。若您不接受本协议的变更，您有权自主决定选择停止使用本服务。若您在公告约定的生效时间后继续使用本服务的，表示您已充分阅读、理解并接受变更修改后的协议内容。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("六、适用法律及管辖条款")]),_vm._v(" "),_c('p',[_vm._v("本协议适用中华人民共和国法律（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区法律）。因浙农网络小贷与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成的，浙农网络小贷和您均同意向被告住所地人民法院提起诉讼。")])]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.show=false}}},[_c('span',{staticClass:"vux-close"})])])],1)],1)}
var check_staticRenderFns = []
var check_esExports = { render: check_render, staticRenderFns: check_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_check = (check_esExports);
// CONCATENATED MODULE: ./src/pages/check.vue
function check_injectStyle (ssrContext) {
  __webpack_require__("raDh")
}
var check_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check___vue_template_functional__ = false
/* styles */
var check___vue_styles__ = check_injectStyle
/* scopeId */
var check___vue_scopeId__ = "data-v-71959789"
/* moduleIdentifier (server only) */
var check___vue_module_identifier__ = null
var check_Component = check_normalizeComponent(
  pages_check,
  selectortype_template_index_0_src_pages_check,
  check___vue_template_functional__,
  check___vue_styles__,
  check___vue_scopeId__,
  check___vue_module_identifier__
)

/* harmony default export */ var src_pages_check = (check_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checkBusiness.vue


var checkBusiness__components;

















/* harmony default export */ var checkBusiness = ({
  created: function created() {
    this.dos();
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: (checkBusiness__components = {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading
  }, defineProperty_default()(checkBusiness__components, 'XButton', vux_src_components_x_button), defineProperty_default()(checkBusiness__components, 'Box', vux_src_components_box), defineProperty_default()(checkBusiness__components, 'Toast', toast["a" /* default */]), defineProperty_default()(checkBusiness__components, 'XDialog', x_dialog["a" /* default */]), defineProperty_default()(checkBusiness__components, 'Tabbar', src_components_tabbar_tabbar), defineProperty_default()(checkBusiness__components, 'TabbarItem', src_components_tabbar_tabbar_item), defineProperty_default()(checkBusiness__components, 'CheckIcon', vux_src_components_check_icon), checkBusiness__components),
  data: function data() {
    return {
      show: false,
      loading: false,
      datas: {},
      entId: '',
      customerNo: '',
      bankNo: '',
      subBranch: '',
      subBranchs: '',
      cardNo: '',
      options: [],
      isagree: false
    };
  },

  methods: {
    dos: function dos() {
      var _this2 = this;

      api_sign.entInfo({ customerNo: this.$route.query.customerNo }).then(function (res) {
        if (res.code == '000000') {
          _this2.datas = res.data;
          if (res.data.signatureStatus == "1" && res.data.paymentStatus == "0") {
            _this2.$router.push({ path: '/checkbusinessm/1', query: { customerNo: _this2.$route.query.customerNo } });
          }
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      var _this = this;
      if (this.datas.showFlag != '1') {
        if (this.cardNo === "") {
          this.$vux.toast.show({
            type: 'cancel;',
            text: '对公账户号不能为空'
          });
          return;
        }
        if (this.bankNo === "") {
          this.$vux.toast.show({
            type: 'cancel;',
            text: '对公账户开户行不能为空	'
          });
          return;
        }
        if (this.subBranch === "") {
          this.$vux.toast.show({
            type: 'cancel;',
            text: '对公账户联行号不能为空'
          });
          return;
        }
      }
      if (this.isagree == false) {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '请勾选协议'
        });
        return;
      }
      var param = new FormData();
      param.append("customerNo", this.$route.query.customerNo);
      if (this.datas.showFlag != '1') {
        param.append("cardNo", this.cardNo);
        param.append("subBranch", this.subBranchs);
        param.append("bankNo", this.bankNo);
      }
      api_sign.nameent(param).then(function (res) {
        if (res.code == '000000') {
          if (_this3.datas.showFlag != '1') {
            _this3.$router.push({ path: '/checkbusinessm/1', query: { customerNo: _this3.$route.query.customerNo } });
          } else {

            _this3.$vux.toast.show({
              type: 'success',
              text: '四要素验证成功！'
            });
            setTimeout(function () {
              _this.$router.go(-1);
            }, 2000);
          }
        } else {
          console.log(_this3.datas.showFlag);
          if (_this3.datas.showFlag != '1') {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          } else {
            _this3.$vux.toast.show({
              width: '220px',
              time: '3000',
              type: 'cancel',
              text: '四要素验证失败，请致电400-178-7833 更新账户信息'
            });
          }
        }
      });
    },
    remoteMethod: function remoteMethod(query) {
      var _this4 = this;

      if (query !== '') {
        this.loading = true;
        api_sign.listsubbranch({ subbranch: query }).then(function (res) {
          if (res.code == '000000') {
            _this4.loading = false;
            _this4.options = res.data;
          } else {
            _this4.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.options = [];
      }
    },
    get: function get(val) {
      for (var i in this.options) {
        if (this.options[i].id == val) {
          this.bankNo = this.options[i].lineNumber;
          this.subBranchs = this.options[i].subbranch;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checkBusiness.vue


var pages_checkBusiness__components;

















/* harmony default export */ var pages_checkBusiness = ({
  created: function created() {
    this.dos();
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: (pages_checkBusiness__components = {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading
  }, defineProperty_default()(pages_checkBusiness__components, 'XButton', vux_src_components_x_button), defineProperty_default()(pages_checkBusiness__components, 'Box', vux_src_components_box), defineProperty_default()(pages_checkBusiness__components, 'Toast', toast["a" /* default */]), defineProperty_default()(pages_checkBusiness__components, 'XDialog', x_dialog["a" /* default */]), defineProperty_default()(pages_checkBusiness__components, 'Tabbar', src_components_tabbar_tabbar), defineProperty_default()(pages_checkBusiness__components, 'TabbarItem', src_components_tabbar_tabbar_item), defineProperty_default()(pages_checkBusiness__components, 'CheckIcon', vux_src_components_check_icon), pages_checkBusiness__components),
  data: function data() {
    return {
      show: false,
      loading: false,
      datas: {},
      entId: '',
      customerNo: '',
      bankNo: '',
      subBranch: '',
      subBranchs: '',
      cardNo: '',
      options: [],
      isagree: false
    };
  },

  methods: {
    dos: function dos() {
      var _this2 = this;

      api_sign.entInfo({ customerNo: this.$route.query.customerNo }).then(function (res) {
        if (res.code == '000000') {
          _this2.datas = res.data;
          if (res.data.signatureStatus == "1" && res.data.paymentStatus == "0") {
            _this2.$router.push({ path: '/checkbusinessm/1', query: { customerNo: _this2.$route.query.customerNo } });
          }
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      var _this = this;
      if (this.datas.showFlag != '1') {
        if (this.cardNo === "") {
          this.$vux.toast.show({
            type: 'cancel;',
            text: '对公账户号不能为空'
          });
          return;
        }
        if (this.bankNo === "") {
          this.$vux.toast.show({
            type: 'cancel;',
            text: '对公账户开户行不能为空	'
          });
          return;
        }
        if (this.subBranch === "") {
          this.$vux.toast.show({
            type: 'cancel;',
            text: '对公账户联行号不能为空'
          });
          return;
        }
      }
      if (this.isagree == false) {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '请勾选协议'
        });
        return;
      }
      var param = new FormData();
      param.append("customerNo", this.$route.query.customerNo);
      if (this.datas.showFlag != '1') {
        param.append("cardNo", this.cardNo);
        param.append("subBranch", this.subBranchs);
        param.append("bankNo", this.bankNo);
      }
      api_sign.nameent(param).then(function (res) {
        if (res.code == '000000') {
          if (_this3.datas.showFlag != '1') {
            _this3.$router.push({ path: '/checkbusinessm/1', query: { customerNo: _this3.$route.query.customerNo } });
          } else {

            _this3.$vux.toast.show({
              type: 'success',
              text: '四要素验证成功！'
            });
            setTimeout(function () {
              _this.$router.go(-1);
            }, 2000);
          }
        } else {
          console.log(_this3.datas.showFlag);
          if (_this3.datas.showFlag != '1') {
            _this3.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          } else {
            _this3.$vux.toast.show({
              width: '220px',
              time: '3000',
              type: 'cancel',
              text: '四要素验证失败，请致电400-178-7833 更新账户信息'
            });
          }
        }
      });
    },
    remoteMethod: function remoteMethod(query) {
      var _this4 = this;

      if (query !== '') {
        this.loading = true;
        api_sign.listsubbranch({ subbranch: query }).then(function (res) {
          if (res.code == '000000') {
            _this4.loading = false;
            _this4.options = res.data;
          } else {
            _this4.$vux.toast.show({
              type: 'cancel;',
              text: res.msg
            });
          }
        });
      } else {
        this.options = [];
      }
    },
    get: function get(val) {
      for (var i in this.options) {
        if (this.options[i].id == val) {
          this.bankNo = this.options[i].lineNumber;
          this.subBranchs = this.options[i].subbranch;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199c548e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkBusiness.vue
var checkBusiness_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{staticClass:"bb",attrs:{"label-width":"9em"}},[_c('cell',{attrs:{"title":"企业名称","value":_vm.datas.name}}),_vm._v(" "),_c('cell',{attrs:{"title":"社会统一信用代码证","value":_vm.datas.idNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"法人姓名","value":_vm.datas.legalPersonName}}),_vm._v(" "),_c('cell',{attrs:{"title":"法人身份证号","value":_vm.datas.legalIdNo}}),_vm._v(" "),(_vm.datas.showFlag !='1')?_c('x-input',{attrs:{"title":"对公账户号","placeholder":"请输入银行卡号","text-align":"right"},model:{value:(_vm.cardNo),callback:function ($$v) {_vm.cardNo=$$v},expression:"cardNo"}}):_vm._e(),_vm._v(" "),(_vm.datas.showFlag != '1')?_c('cell',{attrs:{"title":"对公账户开户行"}},[_c('div',{attrs:{"slot":""},slot:"default"},[_c('el-select',{attrs:{"text-align":"right","filterable":"","remote":"","reserve-keyword":"","placeholder":"请输入开户行","remote-method":_vm.remoteMethod,"loading":_vm.loading},on:{"change":_vm.get},model:{value:(_vm.subBranch),callback:function ($$v) {_vm.subBranch=$$v},expression:"subBranch"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.branchAlias,"value":item.id}})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.datas.showFlag !='1')?_c('x-input',{attrs:{"title":"对公账户联行号","readonly":"","placeholder":"联行号","text-align":"right"},model:{value:(_vm.bankNo),callback:function ($$v) {_vm.bankNo=$$v},expression:"bankNo"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("请仔细核实以上信息，如果存在错误，请联系客服")]),_vm._v(" "),_c('box',{staticStyle:{"text-align":"center","margin-top":"30px"},attrs:{"gap":"10px 10px"}},[_c('label',{staticClass:"lb"},[_c('check-icon',{attrs:{"value":_vm.isagree},on:{"update:value":function($event){_vm.isagree=$event}}},[_vm._v("同意"),_c('a',{staticStyle:{"color":"#0092fe"},on:{"click":function($event){_vm.show=true}}},[_vm._v("《实名认证协议》")])])],1),_vm._v(" "),_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("实名认证")])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{staticClass:"dialog-demo",attrs:{"hide-on-blur":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"content"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("实名认证服务协议")]),_vm._v(" "),_c('p',[_vm._v("实名认证服务协议（以下简称“本协议”）是浙江浙农网络小额贷款有限公司（以下简称“浙农网络小贷”）与用户（以下尊 称“您”）就实名认证服务（以下简称“本服务”或“认证服务”）的使用等相关事项所订立的有效合约。 本协议有助于您了解我们为您提供的服务内容及您的权利和义务，请您仔细阅读。 为便于您使用认证服务，您通过网络页面点击或以其他形式确认本协议的，即视为您已充分理解本协议所有条款，并同意与浙农网络小贷订立本协议并接受本协议的约束。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("一、服务内容")]),_vm._v(" "),_c('p',[_vm._v("实名认证服务：指浙农网络小贷平台用户签署实名认证服务协议，采用身份证、手机号码等进行实名认证。经本平台核实有效后，给与用户实名认证标识的服务。完成实名认证的用户，方可进行贷款申请。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("二、授权与许可")]),_vm._v(" "),_c('p',[_vm._v("1、为了准确核验您的身份，尽量防止您的身份被冒用，您授权浙农网络小贷采集您的设备信息以验证您在进行认证时是否处于可信环境，并根据不同的认证方式按需收集您的身份证件、银行卡号、手机号、企业注册号、企业对公账户等信息。")]),_vm._v(" "),_c('p',[_vm._v("2、为准确验证您的身份，浙农网络小贷需将前款载明的信息提供给合法存有您信息的第三方机构进行比对核验，以便浙农网络小贷核验您的身份真实性。")]),_vm._v(" "),_c('p',[_vm._v("3、实名认证服务适用于本平台的所有用户。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("三、隐私保护")]),_vm._v(" "),_c('p',[_vm._v("1、您在认证时提交给本平台的认证资料，即不可撤销的授权由本平台保留。本平台承诺除法定或约定的事由外，不公开或编辑或透露您的认证资料及保存于本平台的非公开内容用于商业目的，但下列情况除外：")]),_vm._v(" "),_c('p',[_vm._v("（1）您授权本平台透露的相关信息；")]),_vm._v(" "),_c('p',[_vm._v("（2）本平台向国家司法及行政机关提供；")]),_vm._v(" "),_c('p',[_vm._v("（3）第三方和本平台一起为用户提供服务时，该第三方向您提供服务所需的相关信息；")]),_vm._v(" "),_c('p',[_vm._v("我们将采取合理的方式保护您个人资料的安全。我们将使用必要的可以获得的安全技术和程序来保护您的个人资料不被未经授权的访问、使用或泄露。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("四、免责条款")]),_vm._v(" "),_c('p',[_vm._v("您理解并同意，鉴于计算机、互联网的特殊性，下述情况不属于浙农网络小贷违约：")]),_vm._v(" "),_c('p',[_vm._v("1、因自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、网路堵塞、电信部门技术调整和政府管制等导致本服务不能提供或中断；")]),_vm._v(" "),_c('p',[_vm._v("2、黑客攻击造成服务中断、信息数据泄露；但我们应按照本协议约定做好应急处理。")]),_vm._v(" "),_c('p',[_vm._v("3、浙农网络小贷在进行服务器配置、维护时，需要短时间中断服务；")]),_vm._v(" "),_c('p',[_vm._v("4、由于Internet上的通路阻塞造成您网站访问速度下降；")]),_vm._v(" "),_c('p',[_vm._v("5、因国家法律法规及政策的相关要求，中断或终止本服务。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("五、协议变更")]),_vm._v(" "),_c('p',[_vm._v("为了满足您多样化和专业化的服务需求，我们将根据国家法律、法规及其他规范性文件及业务需要，可能增加、变更服务内容或服务方式，并通过本公司平台进行公告。若您不接受本协议的变更，您有权自主决定选择停止使用本服务。若您在公告约定的生效时间后继续使用本服务的，表示您已充分阅读、理解并接受变更修改后的协议内容。")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("六、适用法律及管辖条款")]),_vm._v(" "),_c('p',[_vm._v("本协议适用中华人民共和国法律（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区法律）。因浙农网络小贷与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成的，浙农网络小贷和您均同意向被告住所地人民法院提起诉讼。")])]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.show=false}}},[_c('span',{staticClass:"vux-close"})])])],1),_vm._v(" "),_c('tabbar',{staticClass:"bar"},[_c('tabbar-item',{attrs:{"link":"/"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("HOuS")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mine"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("zxUM")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的合同")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":"","link":"/ren"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("lay7")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("认证信息")])])],1)],1)}
var checkBusiness_staticRenderFns = []
var checkBusiness_esExports = { render: checkBusiness_render, staticRenderFns: checkBusiness_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_checkBusiness = (checkBusiness_esExports);
// CONCATENATED MODULE: ./src/pages/checkBusiness.vue
function checkBusiness_injectStyle (ssrContext) {
  __webpack_require__("Dc4F")
}
var checkBusiness_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checkBusiness___vue_template_functional__ = false
/* styles */
var checkBusiness___vue_styles__ = checkBusiness_injectStyle
/* scopeId */
var checkBusiness___vue_scopeId__ = "data-v-199c548e"
/* moduleIdentifier (server only) */
var checkBusiness___vue_module_identifier__ = null
var checkBusiness_Component = checkBusiness_normalizeComponent(
  pages_checkBusiness,
  selectortype_template_index_0_src_pages_checkBusiness,
  checkBusiness___vue_template_functional__,
  checkBusiness___vue_styles__,
  checkBusiness___vue_scopeId__,
  checkBusiness___vue_module_identifier__
)

/* harmony default export */ var src_pages_checkBusiness = (checkBusiness_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checkBusinessm.vue


var checkBusinessm__components;













/* harmony default export */ var checkBusinessm = ({
  created: function created() {
    this.dos();
  },

  components: (checkBusinessm__components = {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading
  }, defineProperty_default()(checkBusinessm__components, 'XButton', vux_src_components_x_button), defineProperty_default()(checkBusinessm__components, 'Box', vux_src_components_box), defineProperty_default()(checkBusinessm__components, 'Toast', toast["a" /* default */]), defineProperty_default()(checkBusinessm__components, 'Tabbar', src_components_tabbar_tabbar), defineProperty_default()(checkBusinessm__components, 'TabbarItem', src_components_tabbar_tabbar_item), checkBusinessm__components),
  data: function data() {
    return {
      datas: {},
      amount: ''
    };
  },

  methods: {
    dos: function dos() {
      var _this = this;

      api_sign.entInfo({ customerNo: this.$route.query.customerNo }).then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      console.log(this.amount);
      if (this.amount == "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '金额不能为空'
        });
        return;
      }
      var param = new FormData();
      param.append("customerNo", this.datas.customerNo);
      param.append("amount", this.amount);
      api_sign.entpayment(param).then(function (res) {
        if (res.code == '000000') {
          _this2.$router.push('/checkalready');
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checkBusinessm.vue


var pages_checkBusinessm__components;













/* harmony default export */ var pages_checkBusinessm = ({
  created: function created() {
    this.dos();
  },

  components: (pages_checkBusinessm__components = {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    Loading: vux_src_components_loading
  }, defineProperty_default()(pages_checkBusinessm__components, 'XButton', vux_src_components_x_button), defineProperty_default()(pages_checkBusinessm__components, 'Box', vux_src_components_box), defineProperty_default()(pages_checkBusinessm__components, 'Toast', toast["a" /* default */]), defineProperty_default()(pages_checkBusinessm__components, 'Tabbar', src_components_tabbar_tabbar), defineProperty_default()(pages_checkBusinessm__components, 'TabbarItem', src_components_tabbar_tabbar_item), pages_checkBusinessm__components),
  data: function data() {
    return {
      datas: {},
      amount: ''
    };
  },

  methods: {
    dos: function dos() {
      var _this = this;

      api_sign.entInfo({ customerNo: this.$route.query.customerNo }).then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      console.log(this.amount);
      if (this.amount == "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '金额不能为空'
        });
        return;
      }
      var param = new FormData();
      param.append("customerNo", this.datas.customerNo);
      param.append("amount", this.amount);
      api_sign.entpayment(param).then(function (res) {
        if (res.code == '000000') {
          _this2.$router.push('/checkalready');
        } else {
          _this2.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2304ab38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkBusinessm.vue
var checkBusinessm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{staticClass:"bb",attrs:{"label-width":"9em"}},[_c('cell',{attrs:{"title":"企业名称","value":_vm.datas.name}}),_vm._v(" "),_c('cell',{attrs:{"title":"社会统一信用代码证","value":_vm.datas.idNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"法人姓名","value":_vm.datas.legalPersonName}}),_vm._v(" "),_c('cell',{attrs:{"title":"法人身份证号","value":_vm.datas.legalIdNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"对公账户号","value":_vm.datas.cardNo}}),_vm._v(" "),_c('cell',{attrs:{"title":"对公账户开户行","value":_vm.datas.subBranch}}),_vm._v(" "),_c('cell',{attrs:{"title":"对公账户联行号","value":_vm.datas.bankNo}})],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"金额","type":"number","placeholder":"请输入金额"},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("请核对对公银行账户收到的金额")]),_vm._v(" "),_c('box',{staticStyle:{"text-align":"center","margin-top":"30px"},attrs:{"gap":"10px 10px"}},[_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('tabbar',{staticClass:"bar"},[_c('tabbar-item',{attrs:{"link":"/"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("HOuS")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mine"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("zxUM")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的合同")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":"","link":"/ren"}},[_c('img',{staticClass:"icons",attrs:{"slot":"icon","src":__webpack_require__("lay7")},slot:"icon"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("认证信息")])])],1)],1)}
var checkBusinessm_staticRenderFns = []
var checkBusinessm_esExports = { render: checkBusinessm_render, staticRenderFns: checkBusinessm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_checkBusinessm = (checkBusinessm_esExports);
// CONCATENATED MODULE: ./src/pages/checkBusinessm.vue
function checkBusinessm_injectStyle (ssrContext) {
  __webpack_require__("7UU3")
}
var checkBusinessm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checkBusinessm___vue_template_functional__ = false
/* styles */
var checkBusinessm___vue_styles__ = checkBusinessm_injectStyle
/* scopeId */
var checkBusinessm___vue_scopeId__ = "data-v-2304ab38"
/* moduleIdentifier (server only) */
var checkBusinessm___vue_module_identifier__ = null
var checkBusinessm_Component = checkBusinessm_normalizeComponent(
  pages_checkBusinessm,
  selectortype_template_index_0_src_pages_checkBusinessm,
  checkBusinessm___vue_template_functional__,
  checkBusinessm___vue_styles__,
  checkBusinessm___vue_scopeId__,
  checkBusinessm___vue_module_identifier__
)

/* harmony default export */ var src_pages_checkBusinessm = (checkBusinessm_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f660858","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
var _04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n404\n")])}
var _04_staticRenderFns = []
var _04_esExports = { render: _04_render, staticRenderFns: _04_staticRenderFns }
/* harmony default export */ var _04 = (_04_esExports);
// CONCATENATED MODULE: ./src/pages/404.vue
var _04_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var _04___vue_template_functional__ = false
/* styles */
var _04___vue_styles__ = null
/* scopeId */
var _04___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var _04___vue_module_identifier__ = null
var _04_Component = _04_normalizeComponent(
  __vue_script__,
  _04,
  _04___vue_template_functional__,
  _04___vue_styles__,
  _04___vue_scopeId__,
  _04___vue_module_identifier__
)

/* harmony default export */ var pages_404 = (_04_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/contract.vue









/* harmony default export */ var contract = ({
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card, XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      list: [{
        userName: '',
        customerNo: '',
        id: '1'
      }]
    };
  },
  created: function created() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this = this;

      api_sign.entlist().then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    gos: function gos(id) {
      this.$router.push('/contract/' + id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/contract.vue









/* harmony default export */ var pages_contract = ({
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card, XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      list: [{
        userName: '',
        customerNo: '',
        id: '1'
      }]
    };
  },
  created: function created() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this = this;

      api_sign.entlist().then(function (res) {
        if (res.code == '000000') {
          _this.datas = res.data;
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    },
    gos: function gos(id) {
      this.$router.push('/contract/' + id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d403cc2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contract.vue
var contract_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("确认签署")])],1)}
var contract_staticRenderFns = []
var contract_esExports = { render: contract_render, staticRenderFns: contract_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_contract = (contract_esExports);
// CONCATENATED MODULE: ./src/pages/contract.vue
function contract_injectStyle (ssrContext) {
  __webpack_require__("Vllp")
}
var contract_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contract___vue_template_functional__ = false
/* styles */
var contract___vue_styles__ = contract_injectStyle
/* scopeId */
var contract___vue_scopeId__ = "data-v-d403cc2e"
/* moduleIdentifier (server only) */
var contract___vue_module_identifier__ = null
var contract_Component = contract_normalizeComponent(
  pages_contract,
  selectortype_template_index_0_src_pages_contract,
  contract___vue_template_functional__,
  contract___vue_styles__,
  contract___vue_scopeId__,
  contract___vue_module_identifier__
)

/* harmony default export */ var src_pages_contract = (contract_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checkalready.vue
//
//
//
//
//
//
//

/* harmony default export */ var checkalready = ({
  methods: {
    go: function go() {
      this.$router.push("/ren");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/checkalready.vue
//
//
//
//
//
//
//

/* harmony default export */ var pages_checkalready = ({
  methods: {
    go: function go() {
      this.$router.push("/ren");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9732c83c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkalready.vue
var checkalready_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot"},[_c('img',{staticClass:"pg",attrs:{"src":__webpack_require__("rv8P")}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("企业实名认证成功！")]),_vm._v(" "),_c('div',{staticClass:"pp",on:{"click":_vm.go}},[_vm._v("查看认证信息")])])}
var checkalready_staticRenderFns = []
var checkalready_esExports = { render: checkalready_render, staticRenderFns: checkalready_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_checkalready = (checkalready_esExports);
// CONCATENATED MODULE: ./src/pages/checkalready.vue
function checkalready_injectStyle (ssrContext) {
  __webpack_require__("V4h9")
}
var checkalready_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checkalready___vue_template_functional__ = false
/* styles */
var checkalready___vue_styles__ = checkalready_injectStyle
/* scopeId */
var checkalready___vue_scopeId__ = "data-v-9732c83c"
/* moduleIdentifier (server only) */
var checkalready___vue_module_identifier__ = null
var checkalready_Component = checkalready_normalizeComponent(
  pages_checkalready,
  selectortype_template_index_0_src_pages_checkalready,
  checkalready___vue_template_functional__,
  checkalready___vue_styles__,
  checkalready___vue_scopeId__,
  checkalready___vue_module_identifier__
)

/* harmony default export */ var src_pages_checkalready = (checkalready_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/signsuccess.vue
//
//
//
//
//
//
//

/* harmony default export */ var signsuccess = ({
  methods: {
    go: function go() {
      this.$router.push("/ren");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/signsuccess.vue
//
//
//
//
//
//
//

/* harmony default export */ var pages_signsuccess = ({
  methods: {
    go: function go() {
      this.$router.push("/ren");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736e1472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signsuccess.vue
var signsuccess_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bot"},[_c('img',{staticClass:"pg",attrs:{"src":__webpack_require__("rv8P")}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("签约成功！")]),_vm._v(" "),_c('div',{staticClass:"pp",on:{"click":_vm.go}},[_vm._v("查看认证信息")])])}
var signsuccess_staticRenderFns = []
var signsuccess_esExports = { render: signsuccess_render, staticRenderFns: signsuccess_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_signsuccess = (signsuccess_esExports);
// CONCATENATED MODULE: ./src/pages/signsuccess.vue
function signsuccess_injectStyle (ssrContext) {
  __webpack_require__("aEmb")
}
var signsuccess_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var signsuccess___vue_template_functional__ = false
/* styles */
var signsuccess___vue_styles__ = signsuccess_injectStyle
/* scopeId */
var signsuccess___vue_scopeId__ = "data-v-736e1472"
/* moduleIdentifier (server only) */
var signsuccess___vue_module_identifier__ = null
var signsuccess_Component = signsuccess_normalizeComponent(
  pages_signsuccess,
  selectortype_template_index_0_src_pages_signsuccess,
  signsuccess___vue_template_functional__,
  signsuccess___vue_styles__,
  signsuccess___vue_scopeId__,
  signsuccess___vue_module_identifier__
)

/* harmony default export */ var src_pages_signsuccess = (signsuccess_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1665f55a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("w7C9")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/guarantSign.vue










/* harmony default export */ var guarantSign = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XTextarea: vux_src_components_x_textarea,
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      consigneeName: '',
      consigneeAddress: '',
      email: '',
      text1: '请等待',
      show: false
    };
  },

  methods: {
    submits: function submits() {
      var _this = this;

      var param = {
        contractId: this.$route.params.id,
        consigneeName: this.consigneeName,
        consigneeAddress: this.consigneeAddress,
        email: this.email
      };
      if (this.consigneeName === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '收件人不能为空'
        });
        return;
      }
      if (this.email === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '邮箱不能为空'
        });
        return;
      }
      if (this.consigneeAddress === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '收件地址不能为空'
        });
        return;
      }
      this.show = true;
      api_sign.signGuarantee(param).then(function (res) {
        if (res.code == '000000') {
          _this.show = false;
          window.location.href = res.data;
        } else {
          _this.show = false;
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/guarantSign.vue










/* harmony default export */ var pages_guarantSign = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XTextarea: vux_src_components_x_textarea,
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      consigneeName: '',
      consigneeAddress: '',
      email: '',
      text1: '请等待',
      show: false
    };
  },

  methods: {
    submits: function submits() {
      var _this = this;

      var param = {
        contractId: this.$route.params.id,
        consigneeName: this.consigneeName,
        consigneeAddress: this.consigneeAddress,
        email: this.email
      };
      if (this.consigneeName === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '收件人不能为空'
        });
        return;
      }
      if (this.email === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '邮箱不能为空'
        });
        return;
      }
      if (this.consigneeAddress === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '收件地址不能为空'
        });
        return;
      }
      this.show = true;
      api_sign.signGuarantee(param).then(function (res) {
        if (res.code == '000000') {
          _this.show = false;
          window.location.href = res.data;
        } else {
          _this.show = false;
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-301b0ab9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guarantSign.vue
var guarantSign_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"show":_vm.show,"text":_vm.text1}}),_vm._v(" "),_c('group',{staticClass:"bb"},[_c('x-input',{attrs:{"placeholder":"请输入收件人名称"},model:{value:(_vm.consigneeName),callback:function ($$v) {_vm.consigneeName=$$v},expression:"consigneeName"}},[_c('label',{staticStyle:{"width":"6em"},attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              收件人姓名"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v("：\n          ")])]),_vm._v(" "),_c('x-input',{attrs:{"is-type":"email","placeholder":"请输入收件人邮箱"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}},[_c('label',{staticStyle:{"width":"6em"},attrs:{"slot":"label"},slot:"label"},[_vm._v("\n            收件人邮箱"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v("：\n        ")])]),_vm._v(" "),_c('x-textarea',{attrs:{"placeholder":"请输入收件人地址"},model:{value:(_vm.consigneeAddress),callback:function ($$v) {_vm.consigneeAddress=$$v},expression:"consigneeAddress"}},[_c('label',{staticStyle:{"width":"6em"},attrs:{"slot":"label"},slot:"label"},[_vm._v("\n            收件人地址"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v("：\n        ")])])],1),_vm._v(" "),_c('box',{attrs:{"gap":"40px 20px"}},[_c('x-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.submits($event)}}},[_vm._v("下一步")])],1)],1)}
var guarantSign_staticRenderFns = []
var guarantSign_esExports = { render: guarantSign_render, staticRenderFns: guarantSign_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_guarantSign = (guarantSign_esExports);
// CONCATENATED MODULE: ./src/pages/guarantSign.vue
var guarantSign_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var guarantSign___vue_template_functional__ = false
/* styles */
var guarantSign___vue_styles__ = null
/* scopeId */
var guarantSign___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var guarantSign___vue_module_identifier__ = null
var guarantSign_Component = guarantSign_normalizeComponent(
  pages_guarantSign,
  selectortype_template_index_0_src_pages_guarantSign,
  guarantSign___vue_template_functional__,
  guarantSign___vue_styles__,
  guarantSign___vue_scopeId__,
  guarantSign___vue_module_identifier__
)

/* harmony default export */ var src_pages_guarantSign = (guarantSign_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 6 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("S+Gq")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = (datetime_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/extension.vue









/* harmony default export */ var extension = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Datetime: vux_src_components_datetime,
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      extensionDate: '',
      text1: '请等待',
      show: false
    };
  },

  methods: {
    submits: function submits() {
      var _this = this;

      var param = {
        contractId: this.$route.params.id,
        userId: this.$store.state.userInfo.id,
        extensionDate: this.extensionDate
      };
      if (this.extensionDate === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '到期日不能为空'
        });
        return;
      }
      this.show = true;
      api_sign.signExtension(param).then(function (res) {
        if (res.code == '000000') {
          _this.show = false;
          window.location.href = res.data;
        } else {
          _this.show = false;
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/extension.vue









/* harmony default export */ var pages_extension = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Datetime: vux_src_components_datetime,
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      extensionDate: '',
      text1: '请等待',
      show: false
    };
  },

  methods: {
    submits: function submits() {
      var _this = this;

      var param = {
        contractId: this.$route.params.id,
        userId: this.$store.state.userInfo.id,
        extensionDate: this.extensionDate
      };
      if (this.extensionDate === "") {
        this.$vux.toast.show({
          type: 'cancel;',
          text: '到期日不能为空'
        });
        return;
      }
      this.show = true;
      api_sign.signExtension(param).then(function (res) {
        if (res.code == '000000') {
          _this.show = false;
          window.location.href = res.data;
        } else {
          _this.show = false;
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030a93d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/extension.vue
var extension_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"show":_vm.show,"text":_vm.text1}}),_vm._v(" "),_c('group',{staticClass:"bb"},[_c('datetime',{attrs:{"format":"YYYY-MM-DD","title":"展期到期日"},model:{value:(_vm.extensionDate),callback:function ($$v) {_vm.extensionDate=$$v},expression:"extensionDate"}})],1),_vm._v(" "),_c('box',{attrs:{"gap":"40px 20px"}},[_c('x-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.submits($event)}}},[_vm._v("下一步")])],1)],1)}
var extension_staticRenderFns = []
var extension_esExports = { render: extension_render, staticRenderFns: extension_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_extension = (extension_esExports);
// CONCATENATED MODULE: ./src/pages/extension.vue
var extension_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var extension___vue_template_functional__ = false
/* styles */
var extension___vue_styles__ = null
/* scopeId */
var extension___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var extension___vue_module_identifier__ = null
var extension_Component = extension_normalizeComponent(
  pages_extension,
  selectortype_template_index_0_src_pages_extension,
  extension___vue_template_functional__,
  extension___vue_styles__,
  extension___vue_scopeId__,
  extension___vue_module_identifier__
)

/* harmony default export */ var src_pages_extension = (extension_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/entList.vue

















/* harmony default export */ var entList = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Tabbar: src_components_tabbar_tabbar,
    Scroller: vux_src_components_scroller, Spinner: node_modules_vux_src_components_spinner, LoadMore: vux_src_components_load_more,
    Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card,
    Popup: node_modules_vux_src_components_popup,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      list: [],
      signTag: 1,
      password: '',
      page: 0,
      total: 0,
      pageSize: 15,
      mobile: this.$store.state.userInfo.phoneNo,
      show: false,
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      loading: false,
      listLoading: true,
      contractId: '',
      end: 1
    };
  },
  created: function created() {
    this.getList();
    window.addEventListener('scroll', this.onScrollg);
  },

  methods: {
    go: function go(obj) {
      if (obj.realNameStatus == '0') {
        this.$router.push({ path: '/checkbusiness/1', query: { customerNo: obj.customerNo } });
      } else {}
    },
    onScrollg: function onScrollg() {
      var that = this;

      var innerHeight = document.querySelector('#app').clientHeight;

      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

      var scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight;

      if (innerHeight < scrollHeight + scrollTop + 1 && that.end != 0) {

        that.getList();
      }
    },
    handler: function handler(index) {
      if (index == 0) {
        this.signTag = 1;
      } else {
        this.signTag = 0;
      }
      this.list = [];
      this.total = 0;
      this.page = 0;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.end = 0;
      this.page++;
      var pp = {
        realNameTag: this.signTag,
        pageNum: this.page,
        pageSize: this.pageSize,
        enablePaging: true
      };
      this.listLoading = true;
      api_sign.listall(pp).then(function (res) {
        if (res.code == '000000') {
          _this.list = _this.list.concat(res.data.list);
          _this.total = Number(res.data.total);
          _this.listLoading = false;
          if (_this.total == _this.list.length) {
            _this.end = 0;
          } else {
            _this.end = 1;
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
          _this.listLoading = false;
        }
      });
    }
  },
  destroyed: function destroyed() {
    var that = this;
    window.removeEventListener('scroll', that.onScrollg);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/entList.vue

















/* harmony default export */ var pages_entList = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Tabbar: src_components_tabbar_tabbar,
    Scroller: vux_src_components_scroller, Spinner: node_modules_vux_src_components_spinner, LoadMore: vux_src_components_load_more,
    Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item,
    TabbarItem: src_components_tabbar_tabbar_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Card: vux_src_components_card,
    Popup: node_modules_vux_src_components_popup,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input
  },
  data: function data() {
    return {
      list: [],
      signTag: 1,
      password: '',
      page: 0,
      total: 0,
      pageSize: 15,
      mobile: this.$store.state.userInfo.phoneNo,
      show: false,
      codeVal: '获取验证码',
      codeFlog: false,
      wait: 60,
      loading: false,
      listLoading: true,
      contractId: '',
      end: 1
    };
  },
  created: function created() {
    this.getList();
    window.addEventListener('scroll', this.onScrollg);
  },

  methods: {
    go: function go(obj) {
      if (obj.realNameStatus == '0') {
        this.$router.push({ path: '/checkbusiness/1', query: { customerNo: obj.customerNo } });
      } else {}
    },
    onScrollg: function onScrollg() {
      var that = this;

      var innerHeight = document.querySelector('#app').clientHeight;

      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

      var scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight;

      if (innerHeight < scrollHeight + scrollTop + 1 && that.end != 0) {

        that.getList();
      }
    },
    handler: function handler(index) {
      if (index == 0) {
        this.signTag = 1;
      } else {
        this.signTag = 0;
      }
      this.list = [];
      this.total = 0;
      this.page = 0;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.end = 0;
      this.page++;
      var pp = {
        realNameTag: this.signTag,
        pageNum: this.page,
        pageSize: this.pageSize,
        enablePaging: true
      };
      this.listLoading = true;
      api_sign.listall(pp).then(function (res) {
        if (res.code == '000000') {
          _this.list = _this.list.concat(res.data.list);
          _this.total = Number(res.data.total);
          _this.listLoading = false;
          if (_this.total == _this.list.length) {
            _this.end = 0;
          } else {
            _this.end = 1;
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel;',
            text: res.msg
          });
          _this.listLoading = false;
        }
      });
    }
  },
  destroyed: function destroyed() {
    var that = this;
    window.removeEventListener('scroll', that.onScrollg);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a36114e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/entList.vue
var entList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('tab',{attrs:{"line-width":1,"custom-bar-width":"60px"}},[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.handler}},[_vm._v("待实名")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.handler}},[_vm._v("已实名")])],1)],1),_vm._v(" "),_c('div',[(this.list.length=='0')?_c('div',{staticClass:"content"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(col,index){return _c('group',{key:index,class:{topNone:index==0}},[_c('cell',{attrs:{"title":col.name,"is-link":col.realNameStatus=='0',"inline-desc":col.idNo},nativeOn:{"click":function($event){return _vm.go(col)}}},[(col.realNameStatus=='0')?_c('div',{staticClass:"not",attrs:{"slot":""},slot:"default"},[_vm._v("未实名")]):(col.realNameStatus=='1')?_c('div',{staticClass:"notyet",attrs:{"slot":""},slot:"default"},[_vm._v("验证中")]):_c('div',{staticClass:"yes",attrs:{"slot":""},slot:"default"},[_vm._v("已实名")])])],1)}),_vm._v(" "),(_vm.listLoading)?_c('load-more',{attrs:{"tip":"加载中"}}):_vm._e()],2)])}
var entList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('img',{staticClass:"imgs",attrs:{"src":__webpack_require__("LOA1")}}),_vm._v(" "),_c('span',{staticClass:"ts"},[_vm._v("暂无数据")])])}]
var entList_esExports = { render: entList_render, staticRenderFns: entList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_entList = (entList_esExports);
// CONCATENATED MODULE: ./src/pages/entList.vue
function entList_injectStyle (ssrContext) {
  __webpack_require__("8Lpx")
}
var entList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var entList___vue_template_functional__ = false
/* styles */
var entList___vue_styles__ = entList_injectStyle
/* scopeId */
var entList___vue_scopeId__ = "data-v-a36114e8"
/* moduleIdentifier (server only) */
var entList___vue_module_identifier__ = null
var entList_Component = entList_normalizeComponent(
  pages_entList,
  selectortype_template_index_0_src_pages_entList,
  entList___vue_template_functional__,
  entList___vue_styles__,
  entList___vue_scopeId__,
  entList___vue_module_identifier__
)

/* harmony default export */ var src_pages_entList = (entList_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js



var routerPush = vue_router_esm["a" /* default */].prototype.push;
vue_router_esm["a" /* default */].prototype.push = function push(location) {
  return routerPush.call(this, location).catch(function (error) {
    return error;
  });
};
















vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router_router = new vue_router_esm["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/login',
    name: 'bind',
    component: src_pages_login,
    meta: {
      title: '登录'
    }
  }, {
    path: '*',
    component: pages_404,
    meta: {
      title: '404'
    }
  }, {
    path: '/',
    name: 'main',
    component: src_pages_main,
    meta: {
      title: '首页'
    }
  }, {
    path: '/ren',
    name: 'ren',
    component: src_pages_ren,
    meta: {
      title: '认证信息'
    }
  }, {
    path: '/mine',
    name: 'mine',
    component: src_pages_mine,
    meta: {
      title: '我的合同'
    }
  }, {
    path: '/guarantee/:id',
    name: 'guarantee',
    component: src_pages_guarantSign,
    meta: {
      title: '担保合同'
    }
  }, {
    path: '/extension/:id',
    name: 'extension',
    component: src_pages_extension,
    meta: {
      title: '合同要素'
    }
  }, {
    path: '/check',
    name: 'check',
    component: src_pages_check,
    meta: {
      title: '实名认证'
    }
  }, {
    path: '/entList',
    name: 'entList',
    component: src_pages_entList,
    meta: {
      title: '企业实名'
    }
  }, {
    path: '/checkbusiness/:id',
    name: 'checkb',
    component: src_pages_checkBusiness,
    meta: {
      title: '企业实名认证'
    }
  }, {
    path: '/checkbusinessm/:id',
    name: 'checkbm',
    component: src_pages_checkBusinessm,
    meta: {
      title: '企业实名认证'
    }
  }, {
    path: '/contract/:id',
    name: 'contract',
    component: src_pages_contract,
    meta: {
      title: '合同预览'
    }
  }, {
    path: '/checkalready',
    name: 'checkalready',
    component: src_pages_checkalready,
    meta: {
      title: '认证成功'
    }
  }, {
    path: '/checksuc',
    name: 'checksuc',
    component: src_pages_checksuccess,
    meta: {
      title: '认证成功'
    }
  }, {
    path: '/signsuccess',
    name: 'signsuccess',
    component: src_pages_signsuccess,
    meta: {
      title: '签约成功'
    }
  }]
});

router_router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
    if (to.meta.require) {
      if (store.state.phone != 0) {
        next();
      } else {
        router_router.push('/login');
      }
      next();
    } else {
      next();
    }
  }
});

/* harmony default export */ var src_router = (router_router);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      heights: ''
    };
  },

  methods: {
    hhs: function hhs() {
      this.heights = window.screen.height - 153 + 'px';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return {
      heights: ''
    };
  },

  methods: {
    hhs: function hhs() {
      this.heights = window.screen.height - 153 + 'px';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3dbf07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"viewbox"}),_vm._v(" "),_vm._m(0)],1)}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"fot"},[_vm._v("版权所有 © 2022 浙江浙农网络小额贷款有限公司")]),_vm._v(" "),_c('div',{staticClass:"fot"},[_vm._v("客服电话：400-178-7833")])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("cN10")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./src/assets/style.css
var style = __webpack_require__("Q0/0");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/main.js

















element_ui_common_default.a.Select.computed.readonly = function () {

  var isIE = !this.$isServer && !is_nan_default()(Number(document.documentMode));

  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};

vue_esm["default"].use(plugins_toast["a" /* default */]);
vue_esm["default"].use(plugins_alert["a" /* default */]);

vue_esm["default"].use(wechat["a" /* default */]);
vue_esm["default"].use(ajax["a" /* default */]);
vue_esm["default"].use(element_ui_common_default.a);

vue_esm["default"].config.productionTip = false;
vue_esm["default"].filter('formatDateTime', function (value) {
  if (value) {
    var d = new Date(parseInt(value)),
        year = d.getFullYear(),
        month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1),
        day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate(),
        hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours(),
        minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes(),
        seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds();
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  }
});

new vue_esm["default"]({
  router: src_router,
  store: store,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NKGv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "NRm2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P/Wj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAAXNSR0IArs4c6QAAAhBJREFUOBGNVM1rE1EQ/71NohWT0FqpFEXBi5ci1Jsn/4zq3UuDoCBYRQ8KWrGX+gE59eLJHturd0EtTVosiCAI4lfFNkhSItnse76Z5E32i00GsjPzm9/M5L2ZXbV/Zf48NLZhxSNjYrVKtnWstF+tkYLan5s3ZDB69MZVeN6J4wi+fB2EkM8D3S6xejR1bBzjL5dRXr7PoGpcrgTGGK5BiIKqeQ7InT3DLANzQRjlxQUG6cFgeekuA6XHt1nblkDnzQZAv74kGrlAXOddcxdwh/d3PqH18JmDe73Fs0bnXZ3dMImAwUVNT+HwpYtMCj/aq+vsqsZcZZPOGg6m2UOJSiltlJnND6tGh7VXXpfbde346ml6ISFyBCneu47CzDmm2EGGqP3ROMS0DpyZ0JHWB09XmNB5W0sQ5R5LD25CHRlD7vRJGK2hd//wZPReg5PkP3Y/fmbAr+0Mqh0qiC1E024LKIat7ESI/9ZfOyyhaXWHTiaRlQH03oUR9iGjRiRE2yBHiUT6jndqGsVbFeSmJhkJfu+htVSF/vYzjc5YZH5xVunONSlGMSpMWJZkFmwuvoAJAsknu/noufhpRmZB/f0X/PdbkudvbEP/2BU/zZBNdMHC7AyKC9EXwMXiuvWkCr8eWkhLSAxF/23Cr32I56b6xI3LyJ+7eGKaT18Tjz4nvOHWSSONglEhqkG1/gP4e8lprRsL+wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Pzng":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAAXNSR0IArs4c6QAAAmdJREFUOBGdlD9oU1EUxvteXgLBSLAgIg3dCro4CIpWoihOoZPtJC6BkCAoHVxaHQSVdhBHh/yRkDV0EQTBRbDUqWCm4ixuogmWDk2bxN93fffx3lMe1gP33XO+891zzj333jc1hXS73Yxmp9lsFsfj8Qdj6FOv1ydMn6QbcXzkmIt5yNhzhPuoVCPyGnEcZ8XqwUyaJWso5zNyPrJArVZzbBZhY4ZLmF19ej7LxE+n07MCbzFGvuOwXC4PTEkCGo3G/GQyEXtTNkTNK67rfq5UKj88gdS+DilSJnYR19ZoZAI7DpE2ABe1IJVKzVFxD3sGcyDMikkNeQ3nqgXjs7YYx1TrMkPbTRYaViZ60GLLNiFbrdY0tZ0BfAHpku8ssvNxtVr9KNusZGffIWyFSPJtCqOMpwFRSoKk5FN7frLyeJhIyrvYi+A3hdP0q54l4fyGXgU/YNbpXxZJgr3sZTKZE8PhsI9xEvIr8K/o5wyDD1iPDS25OnALQpgOk3z8rWbbL91lXdxAiKRDPmRuBmBY4YIcsMG1MCb9zzMMMXhTucFg8Jpybhiy42wUCoU7pVJpP0SLqEFAss3jec9i8zAjrASDLQxxX4+ctM9fOGowrfPXLPgxfjeRO3YRoGbBpJmKnniedyHGqfkxzM3ZIcvZGOELdoPxmJFm7HN7bufz+Xf09A38a2B/kx2Xv4J6tx3zzmLf4+Wez2azp3K53GleyWq/399NCLbNJbwSPpTEVx1LGDFpwzqH8lCgvYhq7l6EdQQjvDaoML4ekl7mc/AHMd9LqrlPVfq7/590Op2Zdrs99y+rfwFxFhIwdzWhtQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Q0/0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S+Gq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SGRN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TzZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V4h9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VcKD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vllp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xs3t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZFLG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aEmb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cN10":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1/b":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAAE1Jy4DAAAAAXNSR0IArs4c6QAAAylJREFUOBGdVE1oE0EUnplsMdXUJvGnRRRBoRBBPAhS0IM/qJeq4KFJ6qWlUuimRfRQCYL04MFeVKq0ioqIUFvES6GC1J+rioh4qaLiHypWzCa2mtjuzvi9DbvdTVJFJ2T2/Xzv7ffevhnGPIuTnIl3KnoK2sqWkdAv2TAjrl9VTO2zEU6M7XFijJbUamXJt6TzTFx/xphaH9G0WsM0c2QUnHfQ015GomsrCUopXxbb6Ww+j++loDMKOns4Z6+VYmvxwmIZnPM25LxCKdxwx0lGt06iFh0ZRAC75iIJUWnlWlIJy5LXyaeVAlRvrzAmJj+imnrG+SdpyaUOxs4MtofA9oxjFIzvlky1QU84NgBv2NzCseVnwf0WcdNEIAbgbS/QDuALeso4U5UoZlKIqi2WNB+jt4sJbBdpR/1lm27V62fzbNRt0Xx4vOndTF59Zlz9KOuGE5RJ6EOgkOSMmygePzFexjmbTB2UUl6kICH4USlVH8kBjW9ywd/jqQaTyRfkoBXUtFUF0/xQ1IoFCtVxocqId35zgHhtNjI8ILxAJ0Azck9nHAVfbAzApgzIujaPIKh/mKWmgOAtUQDxNQ2P3yfa3YgOD46R1Uh03scshn0IKMj2imy+PmtcdJExsiK4EDPZTzItxdV4USrZkf2N15SN67um4nqMbG7rvIB/lVVrb9AofD2CvqTBI4T49/+dOHegu9EyzdNI0lhKBOVenneMSsFK10O5jEpLxsCMBZGU6i2gqXfR7B1ePNiWj5wXkE12bVfSOoUPv8Frx0w85IKlmVQ3MRURnw9KIBRc4mtFrv1wVP78dRy90hFQ5Q0A0ILeE66uGzDyX+5A3uz1OzIqeBIZGdio4VDsRCnn8G+wpguOf+7J+fOA0PbWDvW/zCb1E0ian3OWS84ICVkTegT3ebo1fTDO+iKxugCmG9eNuRKjNYOTeMyHqaAIHGky+1pRiptq615m5s0HaMuaUl8lHeRmw/u3VfPmZst3QkrBZt466UvK+QSYVDzEFAvsPUpK8h8T4zZoB4ZuXSyeRlvWRUYG7YsgsqgGlyrvhsO9j7jg7hH9Dcu4Pmf+Kt5KAAAAAElFTkSuQmCC"

/***/ }),

/***/ "dJ9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "euia":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h5Pr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hDw7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign.f9e16aa.png";

/***/ }),

/***/ "lay7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAAXNSR0IArs4c6QAAArdJREFUOBGdVE1IVFEUPue+mbGY1BlDJAR3Qm1aBEUZUxQtW6Uwo0QQQTGvTMTNWIukIhcRBaJBIbRLwU0QBG2CxFZBrqR1tInwvTf+lJNv3umcO97He0+y8i7euec73zn33vPd+wB40NhYRiw6pcECkP9eO/JximVChE8y1wMFybd2ZBUC+m712zoKLmiD0Pgq4zCtYuah9Up2n3HQ67fvBwHdNkDb7FPUqwiAiAERSblVWXFRwC0AcG9Tl8KMusBbqEtAtpR/8cTTWxJgpWT3+AgKAprXBIR5C7BC2abPrdOPnZSATr897gdUgcgJiKDgAy3A2kYjzy2W5zjeK56Vxu66D4vQ0twJ1RVPMDP00l7p+oOAglEDJq0cMYmBW7SHeJVgWyAJuP3ly6xY2GIT1yWrV4bbcL120Cd6xIHjOqiwkCIIWmamPoivM+trG8tMWghJEuE2CeaWyvfE3baEgNHBrbXEF71W2DZHg6xXmfvYy207p3FMnZKGaxJL9R0UXWXCZgDI6tMJk4zkD6VY3Dz9rLkE1I4BTPNN+MrCHw5JfBnys1N9SgQ3IC/VFiUJzolvxOrDyF2WWyKAGdy3usbS+NxgMcvKbIqkMZCd7RpGGGTb+zyHXvEBzwrM25jLtVsXcWKiFqHFpmFBubd1ond8Hv0wY6wdHC7wy0I8E1Na+Nzi8/9bTPIkR3JlLkM3sToweIwouNaAdv6iUncVWkejLMmVGoLxL8de4hd9KErg+RcOPUOkO9y/NKsjPRvI7Ye3ngOvWeLTCb5xlxTuyfRwsz8aZMt2sb2RSqePpDPZDrToAMs36i7T6p+KSQ2+hCdDUf72qhMLxlyFajw3M3lLQN1DmfCfbV3sbkY0N9xhshAfDXnXD/kNjURj/Aomcy+nBvmILPAux49Lw53VgZvd/5L+G3SpDxy8TP5SAAAAAElFTkSuQmCC"

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("rxG5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWja":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ma8t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "raDh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rv8P":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADw0lEQVRoQ92aTWxUVRTHf2c+0igfIYQQCQkbKYSEBcQPWKHEFSuJMQVKiLu2kXZSUFy6cKlimymYws5Ap9oY4kpcSGDZISRduAIaTNyIgsRAR50wM8fc+ShvxmnfvTP3tT7e9p17zv/37r3nnnvvEzw8Q1d0c+ovDkqC/Sg7gV6BDSqsM+5FeaLwJ3AX4bZWmC29yPXJd+T3bsNLpw5OzejGcpljKCcqyusCTr4UNCHcRLiUTDI91iePOtHiFNQEGL2kWypJPlRlEFjTSdA2bQoiXEiU+Xz8hPzq4tMaYOCCpnvWMYryMbDWJYiD7QLCJ8UnjF8clKc27awATs3o9lKJGZS9Nk492Myl0vSN9cl8mK9QgOGcHhblK2B9mDPP7x+r8N65fvluOb/LAmSmdKACXwokPYuzcqdQTsD72eNycakGSwIY8SpMom7ZxUqZi5GgogwtBdEWwAwblG9X68u38pmeQHi33XD6D0BmSnsVbq3CmA/rl8cCr2aPy92gYRNAPVXmVzDbhIlufT9XXGBfMMU2AYzk9AzKp65eV9Re+GiiXz5rxFwEMCtsOcGdCBcpX5wLyQo7Giv2IkAmp2dVOe0rSpR+RPgi2y8fmBhVAFOYlZ7yi8faJkr9xnchlWabKQCrAJlpPakVzkUdNcx/QqCiYVa195JgOHtMztcAcjqryj67ptFYvbULdm+FyRtQLIXHECGf7Zf9Ut2M/M1913o+PIS9hRH/dr1MnP8NJq5BWEeY/UTpBV6S4ct6RISv7cP5tQyKN8NnehbyP9vFUOWojOR0DGXUrolfq27E1yYC4zIypd8Dh/xKC/fWtfhaiKsGwNQW28ND1izSSeh7DX74Cf4o2LZqtvMk3jidl8yUPlDYZCPFiB84ADu3wKMCTPzoDuFRvFnEHpo58A9Kjw1ATwqG3oSXN9esXSF8iq/PgaITgGnUKYR38bVJXHQaQo1ecoWIRHytDnroPIldIaISX9cx31UaDeuJiMXX02iXC9lSEHu2PSsPXFdYm4SyuJD5KCVaIQpFWFPPa5GJB6qlhK9irhXCfKFIxTeKORPIVzkdhIhSfDWDNsrpKoDHDY2BGHwD8vfsq0rrMR8wbNrQ+N5Sml1SWD3fiehAm+YtZX0YxXdTbwBif6xiIGJ9sGUAqkeLa8nDil1kuE6F5Y8Wq3Phf3y4m0rzSuutzfN3vN7o01hfcAQhYnvF1ICI9SVfoCd6VfhmBS8+5gSOtN7GtEtZodesjUaxvugOksf2V4PW7ovtzx7txuFq/m7zL22jCidWPtjQAAAAAElFTkSuQmCC"

/***/ }),

/***/ "rxG5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sEtL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "snx3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vcYW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w7C9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xK84":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xMyS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zxUM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAAXNSR0IArs4c6QAAAdpJREFUOBGNVEGrQVEQnne8bIQsrJTs7F7xGyxIKVL2Fv4TfgdZ+AXq3efthZRSFKJEPd79xpvp3uu6zylnznzzzXecmXPPW7fb/bher99kD4NFq9XCmgym0WgEQ2/tdvuGBaOFQoFMLBajzWbjCBlDtgBYd1okEqFms0mNRoNBiPxIkBEiC4Ismkwm/zDKMwCvWq0KeGfV63UGarUa23fMk8mEHZn8NpKYyyJb90JEDr9cLqnX6ynZRQI6nU456CQB0ELF43HKZrNMck5SUWxt2b/8fr/XMjuJsobiJ4gC+NirMSaH/xhEQh46/PVwGJTeVvAKGy6uoOVymVKpFLudTkdgtq7U8/nsCjodF3E4HHJMaukk6taVSoXC4TDHMpkMXyYU/Xg8MqbE1WrFwGKxUKFQKKRrJV4uFwVlcbvx7WZXiePxWOJ+1nqlM36JzzD+Fv7r4LNkPzyvR/GLJhIJKhaLFI1GOXw4HGgwGNB2u/WjM+bqn5dVKpVUDDEIAwsagYL9fl9fFIjgdQEWNAIFd7sdzWYzzZ/P5wQsaOgXLaR0Os11Ez/Iop7OCwnuQ1NOp9MD6ZkouN4BQTy7evT1es2d9BJf9PGamJxNxvt0f89fzPTQkGtB6xeHo6hB3oundQAAAABJRU5ErkJggg=="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a61e6ee6e0e961c76b6a.js